import { CombinedError } from '@urql/core';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import { useUrqlFetcher } from './state/proca';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: any;
  Json: any;
  /**
   * The `Naive DateTime` scalar type represents a naive date and time without
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string.
   */
  NaiveDateTime: any;
};

export type Action = {
  __typename?: 'Action';
  /** Id of action */
  actionId: Scalars['Int'];
  /** Action page this action was collected at */
  actionPage: ActionPage;
  /** Action type */
  actionType: Scalars['String'];
  /** Campaign this action was collected in */
  campaign: Campaign;
  /** supporter contact data */
  contact: Contact;
  /** Timestamp of creation */
  createdAt: Scalars['NaiveDateTime'];
  /** Action custom fields (as stringified JSON) */
  customFields: Scalars['Json'];
  /** Donation specific data */
  donation: Maybe<Donation>;
  /**
   * Deprecated, use customFields
   * @deprecated use custom_fields
   */
  fields: Array<CustomField>;
  /** Consents, privacy data of this action */
  privacy: Consent;
  /** UTM codes */
  tracking: Maybe<Tracking>;
};

export type ActionCustomFields = {
  __typename?: 'ActionCustomFields';
  /** id of action */
  actionId: Scalars['Int'];
  /** type of action */
  actionType: Scalars['String'];
  /** area of supporter that did the action */
  area: Maybe<Scalars['String']>;
  /** custom fields as stringified json */
  customFields: Scalars['Json'];
  /** @deprecated use custom_fields */
  fields: Array<CustomField>;
  /** creation timestamp */
  insertedAt: Scalars['NaiveDateTime'];
};

/** Custom field added to action. For signature it can be contact, for mail it can be subject and body */
export type ActionInput = {
  /** Action Type */
  actionType: Scalars['String'];
  /** Custom fields added to action */
  customFields?: InputMaybe<Scalars['Json']>;
  /** Donation payload */
  donation?: InputMaybe<DonationActionInput>;
  /**
   * Deprecated format: Other fields added to action
   * @deprecated use custom_fields
   */
  fields?: InputMaybe<Array<CustomFieldInput>>;
  /** MTT payload */
  mtt?: InputMaybe<MttActionInput>;
  /** Test mode */
  testing?: InputMaybe<Scalars['Boolean']>;
};

export type ActionPage = {
  /** Campaign this action page belongs to. */
  campaign: Campaign;
  /** Config JSON of this action page */
  config: Scalars['Json'];
  /** Id */
  id: Scalars['Int'];
  /**
   * List of steps in journey
   * @deprecated moved under config
   */
  journey: Array<Scalars['String']>;
  /** Is live? */
  live: Scalars['Boolean'];
  /** Locale for the widget, in i18n format */
  locale: Scalars['String'];
  /** Name where the widget is hosted */
  name: Scalars['String'];
  /** Org the action page belongs to */
  org: Org;
  /** Thank you email templated of this Action Page */
  thankYouTemplate: Maybe<Scalars['String']>;
  /** A reference to thank you email template of this ActionPage */
  thankYouTemplateRef: Maybe<Scalars['String']>;
};

/** ActionPage input */
export type ActionPageInput = {
  /** JSON string containing Action Page config */
  config?: InputMaybe<Scalars['Json']>;
  /** Collected PII is processed even with no opt-in */
  delivery?: InputMaybe<Scalars['Boolean']>;
  /** Extra supporter count. If you want to add a number of signatories you have offline or kept in another system, you can specify the number here. */
  extraSupporters?: InputMaybe<Scalars['Int']>;
  /** 2-letter, lowercase, code of ActionPage language */
  locale?: InputMaybe<Scalars['String']>;
  /**
   * Unique NAME identifying ActionPage.
   *
   * Does not have to exist, must be unique. Can be a 'technical' identifier
   * scoped to particular organization, so it does not have to change when the
   * slugs/names change (eg. some.org/1234). However, frontend Widget can
   * ask for ActionPage by it's current location.href (but without https://), in which case it is useful
   * to make this url match the real widget location.
   */
  name?: InputMaybe<Scalars['String']>;
  /** Supporter confirm email template of this ActionPage */
  supporterConfirmTemplate?: InputMaybe<Scalars['String']>;
  /** Thank you email template of this ActionPage */
  thankYouTemplate?: InputMaybe<Scalars['String']>;
};

export enum ActionPageStatus {
  /** This action page received actions lately */
  Active = 'ACTIVE',
  /** This action page did not receive actions lately */
  Stalled = 'STALLED',
  /** This action page is ready to receive first action or is stalled for over 1 year */
  Standby = 'STANDBY'
}

/** Count of actions for particular action type */
export type ActionTypeCount = {
  __typename?: 'ActionTypeCount';
  /** action type */
  actionType: Scalars['String'];
  /** count of actions of action type */
  count: Scalars['Int'];
};

export type ActivateKeyResult = {
  __typename?: 'ActivateKeyResult';
  status: Status;
};

export type AddKeyInput = {
  /** Name of the key */
  name: Scalars['String'];
  /** Public part of the key (base64url) */
  public: Scalars['String'];
};

/** Address type which can hold different addres fields. */
export type AddressInput = {
  /** Country code (two-letter). */
  country?: InputMaybe<Scalars['String']>;
  /** Locality, which can be a city/town/village */
  locality?: InputMaybe<Scalars['String']>;
  /** Postcode, in format correct for country locale */
  postcode?: InputMaybe<Scalars['String']>;
  /** Region, being province, voyevodship, county */
  region?: InputMaybe<Scalars['String']>;
  /** Street name */
  street?: InputMaybe<Scalars['String']>;
  /** Street number */
  streetNumber?: InputMaybe<Scalars['String']>;
};

/** Api token metadata */
export type ApiToken = {
  __typename?: 'ApiToken';
  expiresAt: Scalars['NaiveDateTime'];
};

/** Count of actions for particular action type */
export type AreaCount = {
  __typename?: 'AreaCount';
  /** area */
  area: Scalars['String'];
  /** count of supporters in this area */
  count: Scalars['Int'];
};

export type Campaign = {
  /**
   * Fetch public actions. Can be used to display recent comments for example.
   *
   * To allow-list action fields to be public, `campaign.public_actions` must be set to a list of strings in form
   * action_type:custom_field_name, eg: `["signature:comment"]`. XXX this cannot be set in API, you need to set in backend.
   */
  actions: PublicActionsResult;
  /** Custom config map */
  config: Scalars['Json'];
  /** Schema for contact personal information */
  contactSchema: ContactSchema;
  /** External ID (if set) */
  externalId: Maybe<Scalars['Int']>;
  /** Campaign id */
  id: Scalars['Int'];
  /** Internal name of the campaign */
  name: Scalars['String'];
  /** Lead org */
  org: Org;
  /** Statistics */
  stats: CampaignStats;
  /** List MTT targets of this campaign */
  targets: Maybe<Array<Maybe<Target>>>;
  /** Full, official name of the campaign */
  title: Scalars['String'];
};


export type CampaignActionsArgs = {
  actionType: Scalars['String'];
  limit: Scalars['Int'];
};

/** Campaign content changed in mutations */
export type CampaignInput = {
  /** Action pages of this campaign */
  actionPages?: InputMaybe<Array<ActionPageInput>>;
  /** Custom config as stringified JSON map */
  config?: InputMaybe<Scalars['Json']>;
  /** Schema for contact personal information */
  contactSchema?: InputMaybe<ContactSchema>;
  /** Campaign external_id. If provided, it will be used to find campaign. Can be used to rename a campaign */
  externalId?: InputMaybe<Scalars['Int']>;
  /** MTT configuration */
  mtt?: InputMaybe<CampaignMttInput>;
  /** Campaign short name */
  name?: InputMaybe<Scalars['String']>;
  /** Campaign human readable title */
  title?: InputMaybe<Scalars['String']>;
};

export type CampaignMtt = {
  __typename?: 'CampaignMtt';
  /** This is last day and end hour of the campaign. Note, every day of the campaign the end hour will be same. */
  endAt: Scalars['DateTime'];
  /**
   * If email templates are used to create MTT, use this template (works like thank you email templates).
   * Otherwise, the raw text that is send with MTT action will make a plain text email.
   */
  messageTemplate: Maybe<Scalars['String']>;
  /** This is first day and start hour of the campaign. Note, every day of the campaign the start hour will be same. */
  startAt: Scalars['DateTime'];
  /** A test target email (yourself) where test mtt actions will be sent (instead to real targets) */
  testEmail: Maybe<Scalars['String']>;
};

export type CampaignMttInput = {
  /** This is last day and end hour of the campaign. Note, every day of the campaign the end hour will be same. */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * If email templates are used to create MTT, use this template (works like thank you email templates).
   * Otherwise, the raw text that is send with MTT action will make a plain text email.
   */
  messageTemplate?: InputMaybe<Scalars['String']>;
  /** This is first day and start hour of the campaign. Note, every day of the campaign the start hour will be same. */
  startAt?: InputMaybe<Scalars['DateTime']>;
  /** A test target email (yourself) where test mtt actions will be sent (instead to real targets) */
  testEmail?: InputMaybe<Scalars['String']>;
};

/** Campaign statistics */
export type CampaignStats = {
  __typename?: 'CampaignStats';
  /** Action counts per action types (with duplicates) */
  actionCount: Array<ActionTypeCount>;
  /** Unique action tagers count */
  supporterCount: Scalars['Int'];
  /** Unique action takers by area */
  supporterCountByArea: Array<AreaCount>;
  /** Unique action takers by org */
  supporterCountByOrg: Array<OrgCount>;
  /** Unique supporter count not including the ones collected by org_name */
  supporterCountByOthers: Scalars['Int'];
};


/** Campaign statistics */
export type CampaignStatsSupporterCountByOthersArgs = {
  orgName: Scalars['String'];
};

export type ChangeUserStatus = {
  __typename?: 'ChangeUserStatus';
  status: Status;
};

export type Confirm = {
  __typename?: 'Confirm';
  /** Secret code/PIN of the confirm */
  code: Scalars['String'];
  /** Who created the confirm */
  creator: Maybe<User>;
  /** Email the confirm is sent to */
  email: Maybe<Scalars['String']>;
  /** Message attached to the confirm */
  message: Maybe<Scalars['String']>;
  /** Object id that confirmable action refers to */
  objectId: Maybe<Scalars['Int']>;
};

export type ConfirmInput = {
  /** secret code of this confirm */
  code: Scalars['String'];
  /** email that confirm was assigned for */
  email?: InputMaybe<Scalars['String']>;
  /** object_id that this confirm refers to */
  objectId?: InputMaybe<Scalars['Int']>;
};

export type ConfirmResult = {
  __typename?: 'ConfirmResult';
  /** Action page if its an object of confirm */
  actionPage: Maybe<ActionPage>;
  /** Campaign page if its an object of confirm */
  campaign: Maybe<Campaign>;
  /** A message attached to the confirm */
  message: Maybe<Scalars['String']>;
  /** Org if its an object of confirm */
  org: Maybe<Org>;
  /** Status of Confirm: Success, Confirming (waiting for confirmation), Noop */
  status: Status;
};

/** GDPR consent data for this org */
export type Consent = {
  __typename?: 'Consent';
  /** Email status, whether it's normal, DOI, or bouncing */
  emailStatus: EmailStatus;
  /** When did the email status change last time */
  emailStatusChanged: Maybe<Scalars['NaiveDateTime']>;
  /** Consent timestamp */
  givenAt: Scalars['NaiveDateTime'];
  /** communication (email) opt-in */
  optIn: Maybe<Scalars['Boolean']>;
  /** This action contained consent (if false, it could be a share action that is attached to another action containing a consent) */
  withConsent: Scalars['Boolean'];
};

/** GDPR consent data structure */
export type ConsentInput = {
  /** Opt in to the campaign leader */
  leadOptIn?: InputMaybe<Scalars['Boolean']>;
  /** Has contact consented to receiving communication from widget owner? Null: not asked */
  optIn?: InputMaybe<Scalars['Boolean']>;
};

export type Contact = {
  __typename?: 'Contact';
  /** Contact ref (fingerprint) of supporter */
  contactRef: Scalars['ID'];
  /** Encryption nonce value */
  nonce: Maybe<Scalars['String']>;
  /** Stringified json with PII optionally encrypted */
  payload: Scalars['String'];
  /** Public key used to encrypt this action */
  publicKey: Maybe<KeyIds>;
  /** Signing key used to encrypt this action */
  signKey: Maybe<KeyIds>;
};

/** Contact information */
export type ContactInput = {
  /** Contacts address */
  address?: InputMaybe<AddressInput>;
  /** Date of birth in format YYYY-MM-DD */
  birthDate?: InputMaybe<Scalars['Date']>;
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First name (when you provide full name split into first and last) */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last name (when you provide full name split into first and last) */
  lastName?: InputMaybe<Scalars['String']>;
  /** Full name */
  name?: InputMaybe<Scalars['String']>;
  /** Nationality information */
  nationality?: InputMaybe<NationalityInput>;
  /** Contacts phone number */
  phone?: InputMaybe<Scalars['String']>;
};

export type ContactReference = {
  __typename?: 'ContactReference';
  /** Contact's reference */
  contactRef: Scalars['String'];
  /** Contacts first name */
  firstName: Maybe<Scalars['String']>;
};

export enum ContactSchema {
  Basic = 'BASIC',
  Eci = 'ECI',
  ItCi = 'IT_CI',
  PopularInitiative = 'POPULAR_INITIATIVE'
}

/** Custom field with a key and value. */
export type CustomField = {
  __typename?: 'CustomField';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Custom field with a key and value. Both are strings. */
export type CustomFieldInput = {
  key: Scalars['String'];
  /** Unused. To mark action_type/key as transient, use campaign.transient_actions list */
  transient?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  status: Status;
};

export type Donation = {
  __typename?: 'Donation';
  /** Provide amount of this donation, in smallest units for currency */
  amount: Scalars['Int'];
  /** Provide currency of this donation */
  currency: Scalars['String'];
  /** Donation frequency unit */
  frequencyUnit: DonationFrequencyUnit;
  /** Donation data */
  payload: Scalars['Json'];
  schema: Maybe<DonationSchema>;
};

export type DonationActionInput = {
  /** Provide amount of this donation, in smallest units for currency */
  amount?: InputMaybe<Scalars['Int']>;
  /** Provide currency of this donation */
  currency?: InputMaybe<Scalars['String']>;
  /** How often is the recurring donation collected */
  frequencyUnit?: InputMaybe<DonationFrequencyUnit>;
  /** Custom JSON data */
  payload: Scalars['Json'];
  /** Provide payload schema to validate, eg. stripe_payment_intent */
  schema?: InputMaybe<DonationSchema>;
};

export enum DonationFrequencyUnit {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  OneOff = 'ONE_OFF',
  Weekly = 'WEEKLY'
}

export enum DonationSchema {
  StripePaymentIntent = 'STRIPE_PAYMENT_INTENT'
}

export enum EmailStatus {
  /** This email was used and blocked */
  Blocked = 'BLOCKED',
  /** This email was used and bounced */
  Bounce = 'BOUNCE',
  /** The user has received a DOI on this email and accepted it */
  DoubleOptIn = 'DOUBLE_OPT_IN',
  /** An unused email. (Warning:  Or used, but we do not store the fact that emails are delivered ok) */
  None = 'NONE',
  /** This email was used and marked spam */
  Spam = 'SPAM',
  /** This email was used and user unsubscribed */
  Unsub = 'UNSUB'
}

export type EmailTemplateInput = {
  /** Html part body */
  html?: InputMaybe<Scalars['String']>;
  /** template locale */
  locale?: InputMaybe<Scalars['String']>;
  /** template name */
  name: Scalars['String'];
  /** Subject text */
  subject?: InputMaybe<Scalars['String']>;
  /** Plaintext part body */
  text?: InputMaybe<Scalars['String']>;
};

export type GenKeyInput = {
  /** Name of the key */
  name: Scalars['String'];
};

export type JoinOrgResult = {
  __typename?: 'JoinOrgResult';
  /** Org that was joined */
  org: Org;
  /** Result of joining - succes or pending confirmation */
  status: Status;
};

/** Encryption or sign key with integer id (database) */
export type Key = {
  __typename?: 'Key';
  /** Is it active? */
  active: Scalars['Boolean'];
  /** Is it expired? */
  expired: Scalars['Boolean'];
  /** When the key was expired, in UTC */
  expiredAt: Maybe<Scalars['NaiveDateTime']>;
  /** Key id */
  id: Scalars['Int'];
  /** Name of the key (human readable) */
  name: Scalars['String'];
  /** Public part of the key (base64url) */
  public: Scalars['String'];
};

export type KeyIds = {
  __typename?: 'KeyIds';
  /** Key id */
  id: Scalars['Int'];
  /** Public part of the key (base64url) */
  public: Scalars['String'];
};

export type KeyWithPrivate = {
  __typename?: 'KeyWithPrivate';
  /** Is it active? */
  active: Scalars['Boolean'];
  /** Is it expired? */
  expired: Scalars['Boolean'];
  /** When the key was expired, in UTC */
  expiredAt: Maybe<Scalars['NaiveDateTime']>;
  /** Key id */
  id: Scalars['Int'];
  /** Name of the key (human readable) */
  name: Scalars['String'];
  /** Private (Secret) part of the key (base64url) */
  private: Scalars['String'];
  /** Public part of the key (base64url) */
  public: Scalars['String'];
};

export type LaunchActionPageResult = {
  __typename?: 'LaunchActionPageResult';
  status: Status;
};

export type MttActionInput = {
  /** Body */
  body?: InputMaybe<Scalars['String']>;
  /** Files to attach (images allowed) */
  files?: InputMaybe<Array<Scalars['String']>>;
  /** Subject line */
  subject?: InputMaybe<Scalars['String']>;
  /** Target ids */
  targets: Array<Scalars['String']>;
};

export type NationalityInput = {
  /** Nationality / issuer of id document */
  country: Scalars['String'];
  /** Document serial id/number */
  documentNumber?: InputMaybe<Scalars['String']>;
  /** Document type */
  documentType?: InputMaybe<Scalars['String']>;
};

export type Org = {
  /** config */
  config: Scalars['Json'];
  /** Organisation short name */
  name: Scalars['String'];
  /** Organisation title (human readable name) */
  title: Scalars['String'];
};

/** Count of supporters for particular org */
export type OrgCount = {
  __typename?: 'OrgCount';
  /** count of supporters registered by org */
  count: Scalars['Int'];
  /** org */
  org: Org;
};

export type OrgInput = {
  /** Config */
  config?: InputMaybe<Scalars['Json']>;
  /** Schema for contact personal information */
  contactSchema?: InputMaybe<ContactSchema>;
  /** Only send thank you emails to opt-ins */
  doiThankYou?: InputMaybe<Scalars['Boolean']>;
  /** Name used to rename */
  name?: InputMaybe<Scalars['String']>;
  /** Email opt in enabled */
  supporterConfirm?: InputMaybe<Scalars['Boolean']>;
  /** Email opt in template name */
  supporterConfirmTemplate?: InputMaybe<Scalars['String']>;
  /** Organisation title (human readable name) */
  title?: InputMaybe<Scalars['String']>;
};

export type OrgUser = {
  __typename?: 'OrgUser';
  /** Date and time the user was created on this instance */
  createdAt: Scalars['NaiveDateTime'];
  email: Scalars['String'];
  /** Date and time when user joined org */
  joinedAt: Scalars['NaiveDateTime'];
  /** Will be removed */
  lastSigninAt: Maybe<Scalars['NaiveDateTime']>;
  /** Role in an org */
  role: Scalars['String'];
};

export type OrgUserInput = {
  /** Email of user */
  email: Scalars['String'];
  /** Role name of user in this org */
  role: Scalars['String'];
};

export type Partnership = {
  __typename?: 'Partnership';
  /** Partner's pages that are part of this campaign (can be more, eg: multiple languages) */
  actionPages: Array<ActionPage>;
  /** The partner staffers who initiated a request */
  launchRequesters: Array<User>;
  /** Join/Launch requests of this partner */
  launchRequests: Array<Confirm>;
  /** Partner org */
  org: Org;
};

export type PersonalData = {
  __typename?: 'PersonalData';
  /** Schema for contact personal information */
  contactSchema: ContactSchema;
  /** Only send thank you emails to opt-ins */
  doiThankYou: Scalars['Boolean'];
  /** High data security enabled */
  highSecurity: Scalars['Boolean'];
  /** Email opt in enabled */
  supporterConfirm: Scalars['Boolean'];
  /** Email opt in template name */
  supporterConfirmTemplate: Maybe<Scalars['String']>;
};

export type PrivateActionPage = ActionPage & {
  __typename?: 'PrivateActionPage';
  /** Campaign this action page belongs to. */
  campaign: Campaign;
  /** Config JSON of this action page */
  config: Scalars['Json'];
  /**
   * Action page collects also opt-out actions, to deliver them to authorities.
   * If false, the opt-outs will fallback to lead (we never trash data with opt-outs)
   */
  delivery: Scalars['Boolean'];
  /** Extra supporters, a number added to deduplicated supporter count. Cannot be added to per-area or per-action_type counts. */
  extraSupporters: Scalars['Int'];
  /** Id */
  id: Scalars['Int'];
  /**
   * List of steps in journey
   * @deprecated moved under config
   */
  journey: Array<Scalars['String']>;
  /** Is live? */
  live: Scalars['Boolean'];
  /** Locale for the widget, in i18n format */
  locale: Scalars['String'];
  /** Location of the widget as last seen in HTTP REFERER header */
  location: Maybe<Scalars['String']>;
  /** Name where the widget is hosted */
  name: Scalars['String'];
  /** Org the action page belongs to */
  org: Org;
  /** Status of action page - STANDBY (ready to get actions), ACTIVE (collecting actions), STALLED (actions not coming any more) */
  status: Maybe<ActionPageStatus>;
  /** Email template to confirm supporter (DOI) */
  supporterConfirmTemplate: Maybe<Scalars['String']>;
  /** Thank you email templated of this Action Page */
  thankYouTemplate: Maybe<Scalars['String']>;
  /** A reference to thank you email template of this ActionPage */
  thankYouTemplateRef: Maybe<Scalars['String']>;
};

export type PrivateCampaign = Campaign & {
  __typename?: 'PrivateCampaign';
  /** Action Pages of this campaign that are accessible to current user */
  actionPages: Array<PrivateActionPage>;
  /**
   * Fetch public actions. Can be used to display recent comments for example.
   *
   * To allow-list action fields to be public, `campaign.public_actions` must be set to a list of strings in form
   * action_type:custom_field_name, eg: `["signature:comment"]`. XXX this cannot be set in API, you need to set in backend.
   */
  actions: PublicActionsResult;
  /** Custom config map */
  config: Scalars['Json'];
  /** Schema for contact personal information */
  contactSchema: ContactSchema;
  /** External ID (if set) */
  externalId: Maybe<Scalars['Int']>;
  /** Campaign onwer collects opt-out actions for delivery even if campaign partner is delivering */
  forceDelivery: Scalars['Boolean'];
  /** Campaign id */
  id: Scalars['Int'];
  /** MTT configuration */
  mtt: Maybe<CampaignMtt>;
  /** Internal name of the campaign */
  name: Scalars['String'];
  /** Lead org */
  org: Org;
  /** List of partnerships and requests to join partnership */
  partnerships: Maybe<Array<Partnership>>;
  /** Statistics */
  stats: CampaignStats;
  /** List MTT targets of this campaign */
  targets: Maybe<Array<Maybe<Target>>>;
  /** Full, official name of the campaign */
  title: Scalars['String'];
};


export type PrivateCampaignActionsArgs = {
  actionType: Scalars['String'];
  limit: Scalars['Int'];
};

export type PrivateOrg = Org & {
  __typename?: 'PrivateOrg';
  /** Get one page belonging to this org */
  actionPage: ActionPage;
  /** List action pages this org has */
  actionPages: Array<ActionPage>;
  /** DEPRECATED: use campaign() in API root. Get campaign this org is leader or partner of by id */
  campaign: Campaign;
  /** List campaigns this org is leader or partner of */
  campaigns: Array<Campaign>;
  /** config */
  config: Scalars['Json'];
  /** Organization id */
  id: Scalars['Int'];
  /** Get encryption key */
  key: Key;
  /** Encryption keys */
  keys: Array<Key>;
  /** Organisation short name */
  name: Scalars['String'];
  /** Personal data settings for this org */
  personalData: PersonalData;
  /** Action processing settings for this org */
  processing: Processing;
  /** Services of this org */
  services: Array<Maybe<Service>>;
  /** Organisation title (human readable name) */
  title: Scalars['String'];
  /** Users of this org */
  users: Array<Maybe<OrgUser>>;
};


export type PrivateOrgActionPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type PrivateOrgActionPagesArgs = {
  select?: InputMaybe<SelectActionPage>;
};


export type PrivateOrgCampaignArgs = {
  id: Scalars['Int'];
};


export type PrivateOrgCampaignsArgs = {
  select?: InputMaybe<SelectCampaign>;
};


export type PrivateOrgKeyArgs = {
  select: SelectKey;
};


export type PrivateOrgKeysArgs = {
  select?: InputMaybe<SelectKey>;
};


export type PrivateOrgServicesArgs = {
  select?: InputMaybe<SelectService>;
};

export type PrivateTarget = Target & {
  __typename?: 'PrivateTarget';
  /** Area of the target */
  area: Maybe<Scalars['String']>;
  /** Email list of this target */
  emails: Array<Maybe<TargetEmail>>;
  /** unique external_id of target, used to upsert target */
  externalId: Scalars['String'];
  /** Custom fields, stringified json */
  fields: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** Locale of this target (in which language do they read emails?) */
  locale: Maybe<Scalars['String']>;
  /** Name of target */
  name: Scalars['String'];
};

export type Processing = {
  __typename?: 'Processing';
  /** Should proca put action in a custom queue, so an external service can do this? */
  customActionConfirm: Scalars['Boolean'];
  /** Should proca put action in custom delivery queue, so an external service can sync it? */
  customActionDeliver: Scalars['Boolean'];
  /** Should proca put events in custom delivery queue, so an external service can sync it? */
  customEventDeliver: Scalars['Boolean'];
  /** Should proca put action in a custom queue, so an external service can do this? */
  customSupporterConfirm: Scalars['Boolean'];
  /** Use a particular owned service type for looking up supporters in CRM */
  detailBackend: Maybe<ServiceName>;
  /** Only send thank you emails to opt-ins */
  doiThankYou: Scalars['Boolean'];
  /** Use a particular owned service type for sending emails */
  emailBackend: Maybe<ServiceName>;
  /** Envelope FROM email when sending emails */
  emailFrom: Maybe<Scalars['String']>;
  /** Email templates. (warn: contant is not available to fetch) */
  emailTemplates: Maybe<Array<Scalars['String']>>;
  /** Use a particular owned service type for sending events */
  eventBackend: Maybe<ServiceName>;
  /** Use a particular owned service type for sending actions */
  pushBackend: Maybe<ServiceName>;
  /** Use a particular owned service type for uploading files */
  storageBackend: Maybe<ServiceName>;
  /** Is the supporter required to double opt in their action (and associated personal data)? */
  supporterConfirm: Scalars['Boolean'];
  /** The email template name that will be used to send the action DOI request */
  supporterConfirmTemplate: Maybe<Scalars['String']>;
};

export type PublicActionPage = ActionPage & {
  __typename?: 'PublicActionPage';
  /** Campaign this action page belongs to. */
  campaign: Campaign;
  /** Config JSON of this action page */
  config: Scalars['Json'];
  /** Id */
  id: Scalars['Int'];
  /**
   * List of steps in journey
   * @deprecated moved under config
   */
  journey: Array<Scalars['String']>;
  /** Is live? */
  live: Scalars['Boolean'];
  /** Locale for the widget, in i18n format */
  locale: Scalars['String'];
  /** Name where the widget is hosted */
  name: Scalars['String'];
  /** Org the action page belongs to */
  org: Org;
  /** Thank you email templated of this Action Page */
  thankYouTemplate: Maybe<Scalars['String']>;
  /** A reference to thank you email template of this ActionPage */
  thankYouTemplateRef: Maybe<Scalars['String']>;
};

/** Result of actions query */
export type PublicActionsResult = {
  __typename?: 'PublicActionsResult';
  /** Custom field keys which are public */
  fieldKeys: Maybe<Array<Scalars['String']>>;
  /** List of actions custom fields */
  list: Maybe<Array<Maybe<ActionCustomFields>>>;
};

export type PublicCampaign = Campaign & {
  __typename?: 'PublicCampaign';
  /**
   * Fetch public actions. Can be used to display recent comments for example.
   *
   * To allow-list action fields to be public, `campaign.public_actions` must be set to a list of strings in form
   * action_type:custom_field_name, eg: `["signature:comment"]`. XXX this cannot be set in API, you need to set in backend.
   */
  actions: PublicActionsResult;
  /** Custom config map */
  config: Scalars['Json'];
  /** Schema for contact personal information */
  contactSchema: ContactSchema;
  /** External ID (if set) */
  externalId: Maybe<Scalars['Int']>;
  /** Campaign id */
  id: Scalars['Int'];
  /** Internal name of the campaign */
  name: Scalars['String'];
  /** Lead org */
  org: Org;
  /** Statistics */
  stats: CampaignStats;
  /** List MTT targets of this campaign */
  targets: Maybe<Array<Maybe<Target>>>;
  /** Full, official name of the campaign */
  title: Scalars['String'];
};


export type PublicCampaignActionsArgs = {
  actionType: Scalars['String'];
  limit: Scalars['Int'];
};

export type PublicOrg = Org & {
  __typename?: 'PublicOrg';
  /** config */
  config: Scalars['Json'];
  /** Organisation short name */
  name: Scalars['String'];
  /** Organisation title (human readable name) */
  title: Scalars['String'];
};

export type PublicTarget = Target & {
  __typename?: 'PublicTarget';
  /** Area of the target */
  area: Maybe<Scalars['String']>;
  /** unique external_id of target, used to upsert target */
  externalId: Scalars['String'];
  /** Custom fields, stringified json */
  fields: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** Locale of this target (in which language do they read emails?) */
  locale: Maybe<Scalars['String']>;
  /** Name of target */
  name: Scalars['String'];
};

export enum Queue {
  /** a custom queue of action that needs moderation */
  CustomActionConfirm = 'CUSTOM_ACTION_CONFIRM',
  /** a custom queue of actions to sync to CRM */
  CustomActionDeliver = 'CUSTOM_ACTION_DELIVER',
  /** a custom queue of action that needs DOI */
  CustomSupporterConfirm = 'CUSTOM_SUPPORTER_CONFIRM',
  /** Queue of thank you email sender worker */
  EmailSupporter = 'EMAIL_SUPPORTER',
  /** Queue of SQS sync worker */
  Sqs = 'SQS',
  /** Queue of webhook sync worker */
  Webhook = 'WEBHOOK'
}

export type RequeueResult = {
  __typename?: 'RequeueResult';
  /** Count of actions selected for requeueing */
  count: Scalars['Int'];
  /** Count of actions that could not be requeued */
  failed: Scalars['Int'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept a confirm on behalf of organisation. */
  acceptOrgConfirm: ConfirmResult;
  /** Accept a confirm by user */
  acceptUserConfirm: ConfirmResult;
  /** A separate key activate operation, because you also need to add the key to receiving system before it is used */
  activateKey: ActivateKeyResult;
  /** Adds an action referencing contact data via contactRef */
  addAction: ContactReference;
  /** Adds an action with contact data */
  addActionContact: ContactReference;
  addActionPage: ActionPage;
  /** Add a new campaign */
  addCampaign: Campaign;
  /** Add a key to encryption keys */
  addKey: Key;
  /** Add an org. Calling user  will become it's owner. */
  addOrg: Org;
  /** Add user to org by email */
  addOrgUser: ChangeUserStatus;
  /**
   * Create stripe object using Stripe key associated with action page owning org.
   * Pass any of paymentIntent, subscription, customer, price json params to be sent as-is to Stripe API. The result is a JSON returned by Stripe API or a GraphQL Error object.
   * If you provide customer along payment intent or subscription, it will be first created, then their id will be added to params for the payment intent or subscription, so you can pack 2 Stripe API calls into one. You can do the same with price object in case of a subscription.
   */
  addStripeObject: Scalars['Json'];
  /** Stripe API - add a stripe payment intent, when donating to the action page specified by id */
  addStripePaymentIntent: Scalars['Json'];
  /** Stripe API - add a stripe subscription, when donating to the action page specified by id */
  addStripeSubscription: Scalars['Json'];
  /**
   * Adds a new Action Page based on another Action Page. Intended to be used to
   * create a partner action page based off lead's one. Copies: campaign, locale, config, delivery flag
   */
  copyActionPage: ActionPage;
  /**
   * Adds a new Action Page based on latest Action Page from campaign. Intended to be used to
   * create a partner action page based off lead's one. Copies: campaign, locale, config, delivery flag
   */
  copyCampaignActionPage: ActionPage;
  /** Delete an action page */
  deleteActionPage: Status;
  /**
   * Delete a campaign.
   * Deletion will be blocked if there are action pages with personal data (we never remove personal data unless via GDPR).
   */
  deleteCampaign: Status;
  /** Delete an org */
  deleteOrg: Status;
  deleteOrgUser: Maybe<DeleteUserResult>;
  /** Generate a new encryption key in org */
  generateKey: KeyWithPrivate;
  /** Invite an user to org by email (can be not yet user!) */
  inviteOrgUser: Confirm;
  /** Try becoming a staffer of the org */
  joinOrg: JoinOrgResult;
  /** Sends a request to lead to set the page to live=true */
  launchActionPage: LaunchActionPageResult;
  /** Link actions with refs to contact with contact reference */
  linkActions: ContactReference;
  /** Reject a confirm on behalf of organisation. */
  rejectOrgConfirm: ConfirmResult;
  /** Reject a confirm by user */
  rejectUserConfirm: ConfirmResult;
  /** Requeue actions into one of processing destinations */
  requeueActions: RequeueResult;
  resetApiToken: Scalars['String'];
  /** Update an Action Page */
  updateActionPage: ActionPage;
  /** Updates an existing campaign. */
  updateCampaign: Campaign;
  /** Update an org */
  updateOrg: PrivateOrg;
  /** Update org processing settings */
  updateOrgProcessing: PrivateOrg;
  updateOrgUser: ChangeUserStatus;
  /** Update (current) user details */
  updateUser: User;
  /**
   * Upserts a campaign.
   *
   * Creates or appends campaign and it's action pages. In case of append, it
   * will change the campaign with the matching name, and action pages with
   * matching names. It will create new action pages if you pass new names. No
   * Action Pages will be removed (principle of not removing signature data).
   */
  upsertCampaign: Campaign;
  /** Insert or update a service for an org, using id to to update a particular one */
  upsertService: Service;
  /**
   * Upsert multiple targets at once.
   * external_id is used to decide if new target record is added, or existing one is updated.
   */
  upsertTargets: Array<Maybe<PrivateTarget>>;
  /**
   * Upsert an email tempalte to be used for sending various emails.
   * It belongs to org and is identified by (name, locale), so you can have multiple "thank_you" templates for different languages.
   */
  upsertTemplate: Maybe<Status>;
};


export type RootMutationTypeAcceptOrgConfirmArgs = {
  confirm: ConfirmInput;
  name: Scalars['String'];
};


export type RootMutationTypeAcceptUserConfirmArgs = {
  confirm: ConfirmInput;
};


export type RootMutationTypeActivateKeyArgs = {
  id: Scalars['Int'];
  orgName: Scalars['String'];
};


export type RootMutationTypeAddActionArgs = {
  action: ActionInput;
  actionPageId: Scalars['Int'];
  contactRef: Scalars['ID'];
  tracking?: InputMaybe<TrackingInput>;
};


export type RootMutationTypeAddActionContactArgs = {
  action: ActionInput;
  actionPageId: Scalars['Int'];
  contact: ContactInput;
  contactRef?: InputMaybe<Scalars['ID']>;
  privacy: ConsentInput;
  tracking?: InputMaybe<TrackingInput>;
};


export type RootMutationTypeAddActionPageArgs = {
  campaignName: Scalars['String'];
  input: ActionPageInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeAddCampaignArgs = {
  input: CampaignInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeAddKeyArgs = {
  input: AddKeyInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeAddOrgArgs = {
  input: OrgInput;
};


export type RootMutationTypeAddOrgUserArgs = {
  input: OrgUserInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeAddStripeObjectArgs = {
  actionPageId: Scalars['Int'];
  customer?: InputMaybe<Scalars['Json']>;
  paymentIntent?: InputMaybe<Scalars['Json']>;
  price?: InputMaybe<Scalars['Json']>;
  subscription?: InputMaybe<Scalars['Json']>;
  testing?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeAddStripePaymentIntentArgs = {
  actionPageId: Scalars['Int'];
  contactRef?: InputMaybe<Scalars['ID']>;
  input: StripePaymentIntentInput;
  testing?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeAddStripeSubscriptionArgs = {
  actionPageId: Scalars['Int'];
  contactRef?: InputMaybe<Scalars['ID']>;
  input: StripeSubscriptionInput;
  testing?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeCopyActionPageArgs = {
  fromName: Scalars['String'];
  name: Scalars['String'];
  orgName: Scalars['String'];
};


export type RootMutationTypeCopyCampaignActionPageArgs = {
  fromCampaignName: Scalars['String'];
  name: Scalars['String'];
  orgName: Scalars['String'];
};


export type RootMutationTypeDeleteActionPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteCampaignArgs = {
  externalId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteOrgArgs = {
  name: Scalars['String'];
};


export type RootMutationTypeDeleteOrgUserArgs = {
  email: Scalars['String'];
  orgName: Scalars['String'];
};


export type RootMutationTypeGenerateKeyArgs = {
  input: GenKeyInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeInviteOrgUserArgs = {
  input: OrgUserInput;
  message?: InputMaybe<Scalars['String']>;
  orgName: Scalars['String'];
};


export type RootMutationTypeJoinOrgArgs = {
  name: Scalars['String'];
};


export type RootMutationTypeLaunchActionPageArgs = {
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type RootMutationTypeLinkActionsArgs = {
  actionPageId: Scalars['Int'];
  contactRef: Scalars['ID'];
  linkRefs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootMutationTypeRejectOrgConfirmArgs = {
  confirm: ConfirmInput;
  name: Scalars['String'];
};


export type RootMutationTypeRejectUserConfirmArgs = {
  confirm: ConfirmInput;
};


export type RootMutationTypeRequeueActionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  orgName: Scalars['String'];
  queue: Queue;
};


export type RootMutationTypeUpdateActionPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: ActionPageInput;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateCampaignArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: CampaignInput;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateOrgArgs = {
  input: OrgInput;
  name: Scalars['String'];
};


export type RootMutationTypeUpdateOrgProcessingArgs = {
  customActionConfirm?: InputMaybe<Scalars['Boolean']>;
  customActionDeliver?: InputMaybe<Scalars['Boolean']>;
  customEventDeliver?: InputMaybe<Scalars['Boolean']>;
  customSupporterConfirm?: InputMaybe<Scalars['Boolean']>;
  detailBackend?: InputMaybe<ServiceName>;
  doiThankYou?: InputMaybe<Scalars['Boolean']>;
  emailBackend?: InputMaybe<ServiceName>;
  emailFrom?: InputMaybe<Scalars['String']>;
  eventBackend?: InputMaybe<ServiceName>;
  name: Scalars['String'];
  pushBackend?: InputMaybe<ServiceName>;
  storageBackend?: InputMaybe<ServiceName>;
  supporterConfirm?: InputMaybe<Scalars['Boolean']>;
  supporterConfirmTemplate?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateOrgUserArgs = {
  input: OrgUserInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input: UserDetailsInput;
};


export type RootMutationTypeUpsertCampaignArgs = {
  input: CampaignInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeUpsertServiceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: ServiceInput;
  orgName: Scalars['String'];
};


export type RootMutationTypeUpsertTargetsArgs = {
  campaignId: Scalars['Int'];
  replace?: InputMaybe<Scalars['Boolean']>;
  targets: Array<TargetInput>;
};


export type RootMutationTypeUpsertTemplateArgs = {
  input: EmailTemplateInput;
  orgName: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Get action page.
   * Depending on your access (page owner, lead, instance admin),
   * you will get private or public view of the page.
   */
  actionPage: ActionPage;
  /**
   * Get one campaign. If you have access to the campaign, as lead or
   * partner, you will get a private view of the campaign, otherwise, a public
   * view.
   */
  campaign: Maybe<Campaign>;
  /** Returns a public list of campaigns, filtered by title. Can be used to implement a campaign search box on a website. */
  campaigns: Array<Campaign>;
  /** Get the current user, as determined by Authorization header */
  currentUser: User;
  /** Export actions collected by org, optionally filtered by campaign */
  exportActions: Array<Maybe<Action>>;
  /** Organization api (authenticated) */
  org: PrivateOrg;
  /** Select users from this instnace. Requires a manage users admin permission. */
  users: Array<User>;
};


export type RootQueryTypeActionPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeCampaignArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeCampaignsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeExportActionsArgs = {
  after?: InputMaybe<Scalars['DateTime']>;
  campaignId?: InputMaybe<Scalars['Int']>;
  campaignName?: InputMaybe<Scalars['String']>;
  includeTesting?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyDoubleOptIn?: InputMaybe<Scalars['Boolean']>;
  onlyOptIn?: InputMaybe<Scalars['Boolean']>;
  orgName: Scalars['String'];
  start?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeOrgArgs = {
  name: Scalars['String'];
};


export type RootQueryTypeUsersArgs = {
  select?: InputMaybe<SelectUser>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  actionPageUpserted: ActionPage;
};


export type RootSubscriptionTypeActionPageUpsertedArgs = {
  orgName?: InputMaybe<Scalars['String']>;
};

export type SelectActionPage = {
  /** Filter by campaign Id */
  campaignId?: InputMaybe<Scalars['Int']>;
};

export type SelectCampaign = {
  orgName?: InputMaybe<Scalars['String']>;
  titleLike?: InputMaybe<Scalars['String']>;
};

export type SelectKey = {
  /** Only active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Key id */
  id?: InputMaybe<Scalars['Int']>;
  /** Key having this public part */
  public?: InputMaybe<Scalars['String']>;
};

export type SelectService = {
  name?: InputMaybe<ServiceName>;
};

/** Criteria to filter users */
export type SelectUser = {
  /** Use % as wildcard */
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  /** Exact org name */
  orgName?: InputMaybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  /** Hostname of service, but can be used as any "container" of the service. For AWS, contains a region. */
  host: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['Int'];
  /** Service name (type) */
  name: ServiceName;
  /** A sub-selector of a resource. Can be url path, but can be something like AWS bucket name */
  path: Maybe<Scalars['String']>;
  /** User, Account id, client id, whatever your API has */
  user: Maybe<Scalars['String']>;
};

export type ServiceInput = {
  /** Hostname of service, but can be used as any "container" of the service. For AWS, contains a region. */
  host?: InputMaybe<Scalars['String']>;
  /** Service name (type) */
  name: ServiceName;
  /** Password, key, secret or whatever your API has as secret credential */
  password?: InputMaybe<Scalars['String']>;
  /** A sub-selector of a resource. Can be url path, but can be something like AWS bucket name */
  path?: InputMaybe<Scalars['String']>;
  /** User, Account id, client id, whatever your API has */
  user?: InputMaybe<Scalars['String']>;
};

export enum ServiceName {
  /** Mailjet to send emails */
  Mailjet = 'MAILJET',
  /** AWS SES to send emails */
  Ses = 'SES',
  /** SMTP to send emails */
  Smtp = 'SMTP',
  /** AWS SQS to process messages */
  Sqs = 'SQS',
  /** Stripe to process donations */
  Stripe = 'STRIPE',
  /** Supabase to store files */
  Supabase = 'SUPABASE',
  /** Use a service that instance org is using */
  System = 'SYSTEM',
  /** Stripe test account to test donations */
  TestStripe = 'TEST_STRIPE',
  /** HTTP POST webhook */
  Webhook = 'WEBHOOK',
  /** Wordpress HTTP API */
  Wordpress = 'WORDPRESS'
}

export enum Status {
  /** Operation awaiting confirmation */
  Confirming = 'CONFIRMING',
  /** Operation had no effect (already done) */
  Noop = 'NOOP',
  /** Operation completed succesfully */
  Success = 'SUCCESS'
}

export type StripePaymentIntentInput = {
  /** Amount of payment */
  amount: Scalars['Int'];
  /** Currency ofo payment */
  currency: Scalars['String'];
  /** Stripe payment method type */
  paymentMethodTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type StripeSubscriptionInput = {
  /** Amount of payment */
  amount: Scalars['Int'];
  /** Currency ofo payment */
  currency: Scalars['String'];
  /** how often is recurrent payment made? */
  frequencyUnit: DonationFrequencyUnit;
};

export type Target = {
  /** Area of the target */
  area: Maybe<Scalars['String']>;
  /** unique external_id of target, used to upsert target */
  externalId: Scalars['String'];
  /** Custom fields, stringified json */
  fields: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  /** Locale of this target (in which language do they read emails?) */
  locale: Maybe<Scalars['String']>;
  /** Name of target */
  name: Scalars['String'];
};

export type TargetEmail = {
  __typename?: 'TargetEmail';
  /** Email of target */
  email: Scalars['String'];
  /** The status of email (normal or bouncing etc) */
  emailStatus: EmailStatus;
  /** An error received when bouncing email was reported */
  error: Maybe<Scalars['String']>;
};

export type TargetEmailInput = {
  /** Email of target */
  email: Scalars['String'];
};

export type TargetInput = {
  /** Area of the target */
  area?: InputMaybe<Scalars['String']>;
  /** Email list of this target */
  emails?: InputMaybe<Array<TargetEmailInput>>;
  /** unique external_id of target, used to upsert target */
  externalId: Scalars['String'];
  /** Custom fields, stringified json */
  fields?: InputMaybe<Scalars['Json']>;
  /** Locale of this target (in which language do they read emails?) */
  locale?: InputMaybe<Scalars['String']>;
  /** Name of target */
  name?: InputMaybe<Scalars['String']>;
};

/** Tracking codes (UTM params) */
export type Tracking = {
  __typename?: 'Tracking';
  campaign: Scalars['String'];
  content: Scalars['String'];
  medium: Scalars['String'];
  source: Scalars['String'];
};

/** Tracking codes, utm medium/campaign/source default to 'unknown', content to empty string */
export type TrackingInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  /** Action page location. Url from which action is added. Must contain schema, domain, (port), pathname */
  location?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  /** Users API token (to check expiry) */
  apiToken: Maybe<ApiToken>;
  /** Email of user */
  email: Scalars['String'];
  /** Id of user */
  id: Scalars['Int'];
  /** Is user an admin? */
  isAdmin: Scalars['Boolean'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']>;
  /** Phone */
  phone: Maybe<Scalars['String']>;
  /** Url to profile picture */
  pictureUrl: Maybe<Scalars['String']>;
  /** user's roles in orgs */
  roles: Array<UserRole>;
};

export type UserDetailsInput = {
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Users profile pic url */
  pictureUrl?: InputMaybe<Scalars['String']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  /** Org this role is in */
  org: Org;
  /** Role name */
  role: Scalars['String'];
};

type ActionPageIds_PrivateActionPage_Fragment = { __typename?: 'PrivateActionPage', id: number, name: string, locale: string };

type ActionPageIds_PublicActionPage_Fragment = { __typename?: 'PublicActionPage', id: number, name: string, locale: string };

export type ActionPageIdsFragment = ActionPageIds_PrivateActionPage_Fragment | ActionPageIds_PublicActionPage_Fragment;

type ActionPageFields_PrivateActionPage_Fragment = { __typename: 'PrivateActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> };

type ActionPageFields_PublicActionPage_Fragment = { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> };

export type ActionPageFieldsFragment = ActionPageFields_PrivateActionPage_Fragment | ActionPageFields_PublicActionPage_Fragment;

export type ActionPagePrivateFieldsFragment = { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null };

type ActionPageComplete_PrivateActionPage_Fragment = { __typename: 'PrivateActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string } };

type ActionPageComplete_PublicActionPage_Fragment = { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string } };

export type ActionPageCompleteFragment = ActionPageComplete_PrivateActionPage_Fragment | ActionPageComplete_PublicActionPage_Fragment;

type OrgActionPage_PrivateActionPage_Fragment = { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } };

type OrgActionPage_PublicActionPage_Fragment = { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } };

export type OrgActionPageFragment = OrgActionPage_PrivateActionPage_Fragment | OrgActionPage_PublicActionPage_Fragment;

export type ActionPagesQueryVariables = Exact<{
  org: Scalars['String'];
}>;


export type ActionPagesQuery = { __typename?: 'RootQueryType', org: { __typename?: 'PrivateOrg', actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } }> } };

export type ActionPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ActionPageQuery = { __typename?: 'RootQueryType', actionPage: { __typename: 'PrivateActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string } } };

export type GetActionPageByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetActionPageByNameQuery = { __typename?: 'RootQueryType', actionPage: { __typename: 'PrivateActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } };

export type GetOrgActionPageQueryVariables = Exact<{
  orgName: Scalars['String'];
  name: Scalars['String'];
}>;


export type GetOrgActionPageQuery = { __typename?: 'RootQueryType', org: { __typename?: 'PrivateOrg', actionPage: { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } } };

export type UpdateActionPageMutationVariables = Exact<{
  id: Scalars['Int'];
  actionPage: ActionPageInput;
}>;


export type UpdateActionPageMutation = { __typename?: 'RootMutationType', updateActionPage: { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } };

export type AddActionPageMutationVariables = Exact<{
  orgName: Scalars['String'];
  campaignName: Scalars['String'];
  name: Scalars['String'];
  locale: Scalars['String'];
  config?: InputMaybe<Scalars['Json']>;
}>;


export type AddActionPageMutation = { __typename?: 'RootMutationType', addActionPage: { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } };

type CampaignIds_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string };

type CampaignIds_PublicCampaign_Fragment = { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string };

export type CampaignIdsFragment = CampaignIds_PrivateCampaign_Fragment | CampaignIds_PublicCampaign_Fragment;

type CampaignExportIds_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', name: string, externalId: number | null };

type CampaignExportIds_PublicCampaign_Fragment = { __typename: 'PublicCampaign', name: string, externalId: number | null };

export type CampaignExportIdsFragment = CampaignExportIds_PrivateCampaign_Fragment | CampaignExportIds_PublicCampaign_Fragment;

type CampaignFields_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any };

type CampaignFields_PublicCampaign_Fragment = { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any };

export type CampaignFieldsFragment = CampaignFields_PrivateCampaign_Fragment | CampaignFields_PublicCampaign_Fragment;

export type CampaignPrivateFieldsFragment = { __typename: 'PrivateCampaign', forceDelivery: boolean };

type CampaignCoalitionStats_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } };

type CampaignCoalitionStats_PublicCampaign_Fragment = { __typename: 'PublicCampaign', stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } };

export type CampaignCoalitionStatsFragment = CampaignCoalitionStats_PrivateCampaign_Fragment | CampaignCoalitionStats_PublicCampaign_Fragment;

type CampaignInfo_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } };

type CampaignInfo_PublicCampaign_Fragment = { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } };

export type CampaignInfoFragment = CampaignInfo_PrivateCampaign_Fragment | CampaignInfo_PublicCampaign_Fragment;

export type GetCampaignQueryVariables = Exact<{
  org: Scalars['String'];
  id: Scalars['Int'];
}>;


export type GetCampaignQuery = { __typename?: 'RootQueryType', org: { __typename?: 'PrivateOrg', campaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }> } };

export type GetCampaignConfigQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignConfigQuery = { __typename?: 'RootQueryType', campaign: { __typename?: 'PrivateCampaign', config: any } | { __typename?: 'PublicCampaign', config: any } | null };

export type UpsertCampaignMutationVariables = Exact<{
  org: Scalars['String'];
  campaign: CampaignInput;
}>;


export type UpsertCampaignMutation = { __typename?: 'RootMutationType', upsertCampaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } };

export type AddCampaignMutationVariables = Exact<{
  org: Scalars['String'];
  campaign: CampaignInput;
}>;


export type AddCampaignMutation = { __typename?: 'RootMutationType', addCampaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } };

export type UpdateCampaignByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  campaign: CampaignInput;
}>;


export type UpdateCampaignByIdMutation = { __typename?: 'RootMutationType', updateCampaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } };

type PublicCampaignInfo_PrivateCampaign_Fragment = { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } };

type PublicCampaignInfo_PublicCampaign_Fragment = { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } };

export type PublicCampaignInfoFragment = PublicCampaignInfo_PrivateCampaign_Fragment | PublicCampaignInfo_PublicCampaign_Fragment;

export type FindPublicCampaignQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}>;


export type FindPublicCampaignQuery = { __typename?: 'RootQueryType', campaigns: Array<{ __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } }> };

export type CampaignQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CampaignQuery = { __typename?: 'RootQueryType', campaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | null };

export type CampaignsQueryVariables = Exact<{
  org: Scalars['String'];
}>;


export type CampaignsQuery = { __typename?: 'RootQueryType', org: { __typename?: 'PrivateOrg', campaigns: Array<{ __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } }> } };

export type AddCampaignPageMutationVariables = Exact<{
  org: Scalars['String'];
  campaignName: Scalars['String'];
  campaign: CampaignInput;
  page: ActionPageInput;
}>;


export type AddCampaignPageMutation = { __typename?: 'RootMutationType', addCampaign: { __typename: 'PrivateCampaign', forceDelivery: boolean, id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, contactSchema: ContactSchema, config: any, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any }, stats: { __typename?: 'CampaignStats', supporterCount: number, supporterCountByOrg: Array<{ __typename?: 'OrgCount', count: number, org: { __typename?: 'PrivateOrg', name: string, title: string } | { __typename?: 'PublicOrg', name: string, title: string } }>, actionCount: Array<{ __typename?: 'ActionTypeCount', actionType: string, count: number }> } }, addActionPage: { __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string>, campaign: { __typename: 'PrivateCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } | { __typename: 'PublicCampaign', id: number, externalId: number | null, name: string, title: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } } } };

export type ServiceFieldsFragment = { __typename: 'Service', id: number, name: ServiceName, host: string | null, user: string | null, path: string | null };

export type ContactExportFragment = { __typename?: 'Contact', contactRef: string, payload: string, nonce: string | null, publicKey: { __typename?: 'KeyIds', id: number, public: string } | null, signKey: { __typename?: 'KeyIds', id: number, public: string } | null };

export type ActionExportFragment = { __typename?: 'Action', actionId: number, actionType: string, createdAt: any, customFields: any, contact: { __typename?: 'Contact', contactRef: string, payload: string, nonce: string | null, publicKey: { __typename?: 'KeyIds', id: number, public: string } | null, signKey: { __typename?: 'KeyIds', id: number, public: string } | null }, tracking: { __typename?: 'Tracking', source: string, medium: string, campaign: string, content: string } | null, privacy: { __typename?: 'Consent', optIn: boolean | null, givenAt: any, emailStatus: EmailStatus, emailStatusChanged: any | null, withConsent: boolean } };

export type ExportCampaignActionsQueryVariables = Exact<{
  org: Scalars['String'];
  campaignId?: InputMaybe<Scalars['Int']>;
  campaignName?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyOptIn?: InputMaybe<Scalars['Boolean']>;
  onlyDoubleOptIn?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportCampaignActionsQuery = { __typename?: 'RootQueryType', exportActions: Array<{ __typename?: 'Action', actionId: number, actionType: string, createdAt: any, customFields: any, actionPage: { __typename?: 'PrivateActionPage', id: number, name: string, locale: string } | { __typename?: 'PublicActionPage', id: number, name: string, locale: string }, contact: { __typename?: 'Contact', contactRef: string, payload: string, nonce: string | null, publicKey: { __typename?: 'KeyIds', id: number, public: string } | null, signKey: { __typename?: 'KeyIds', id: number, public: string } | null }, tracking: { __typename?: 'Tracking', source: string, medium: string, campaign: string, content: string } | null, privacy: { __typename?: 'Consent', optIn: boolean | null, givenAt: any, emailStatus: EmailStatus, emailStatusChanged: any | null, withConsent: boolean } } | null> };

export type ExportOrgActionsQueryVariables = Exact<{
  org: Scalars['String'];
  start?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyOptIn?: InputMaybe<Scalars['Boolean']>;
  onlyDoubleOptIn?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportOrgActionsQuery = { __typename?: 'RootQueryType', exportActions: Array<{ __typename?: 'Action', actionId: number, actionType: string, createdAt: any, customFields: any, actionPage: { __typename?: 'PrivateActionPage', id: number, name: string, locale: string } | { __typename?: 'PublicActionPage', id: number, name: string, locale: string }, campaign: { __typename: 'PrivateCampaign', name: string, externalId: number | null } | { __typename: 'PublicCampaign', name: string, externalId: number | null }, contact: { __typename?: 'Contact', contactRef: string, payload: string, nonce: string | null, publicKey: { __typename?: 'KeyIds', id: number, public: string } | null, signKey: { __typename?: 'KeyIds', id: number, public: string } | null }, tracking: { __typename?: 'Tracking', source: string, medium: string, campaign: string, content: string } | null, privacy: { __typename?: 'Consent', optIn: boolean | null, givenAt: any, emailStatus: EmailStatus, emailStatusChanged: any | null, withConsent: boolean } } | null> };

export type KeyFieldsFragment = { __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null };

export type ListKeysQueryVariables = Exact<{
  org: Scalars['String'];
}>;


export type ListKeysQuery = { __typename?: 'RootQueryType', org: { __typename?: 'PrivateOrg', keys: Array<{ __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null }> } };

export type GenerateKeyMutationVariables = Exact<{
  org: Scalars['String'];
  input: GenKeyInput;
}>;


export type GenerateKeyMutation = { __typename?: 'RootMutationType', generateKey: { __typename?: 'KeyWithPrivate', id: number, name: string, public: string, private: string, active: boolean, expired: boolean, expiredAt: any | null } };

export type AddKeyMutationVariables = Exact<{
  org: Scalars['String'];
  input: AddKeyInput;
}>;


export type AddKeyMutation = { __typename?: 'RootMutationType', addKey: { __typename?: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null } };

export type ActivateKeyMutationVariables = Exact<{
  org: Scalars['String'];
  id: Scalars['Int'];
}>;


export type ActivateKeyMutation = { __typename?: 'RootMutationType', activateKey: { __typename?: 'ActivateKeyResult', status: Status } };

type OrgIds_PrivateOrg_Fragment = { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any };

type OrgIds_PublicOrg_Fragment = { __typename: 'PublicOrg', name: string, title: string, config: any };

export type OrgIdsFragment = OrgIds_PrivateOrg_Fragment | OrgIds_PublicOrg_Fragment;

type OrgFields_PrivateOrg_Fragment = { __typename: 'PrivateOrg', name: string, title: string };

type OrgFields_PublicOrg_Fragment = { __typename: 'PublicOrg', name: string, title: string };

export type OrgFieldsFragment = OrgFields_PrivateOrg_Fragment | OrgFields_PublicOrg_Fragment;

export type OrgPrivateFieldsFragment = { __typename: 'PrivateOrg', id: number, config: any, personalData: { __typename?: 'PersonalData', contactSchema: ContactSchema } };

export type OrgInfoFragment = { __typename: 'PrivateOrg', name: string, title: string, id: number, config: any, keys: Array<{ __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null }>, services: Array<{ __typename: 'Service', id: number, name: ServiceName, host: string | null, user: string | null, path: string | null } | null>, personalData: { __typename?: 'PersonalData', contactSchema: ContactSchema } };

export type GetOrgQueryVariables = Exact<{
  org: Scalars['String'];
}>;


export type GetOrgQuery = { __typename?: 'RootQueryType', org: { __typename: 'PrivateOrg', name: string, title: string, id: number, config: any, keys: Array<{ __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null }>, services: Array<{ __typename: 'Service', id: number, name: ServiceName, host: string | null, user: string | null, path: string | null } | null>, personalData: { __typename?: 'PersonalData', contactSchema: ContactSchema } } };

export type UpdateOrgMutationVariables = Exact<{
  orgName: Scalars['String'];
  org: OrgInput;
}>;


export type UpdateOrgMutation = { __typename?: 'RootMutationType', updateOrg: { __typename: 'PrivateOrg', name: string, title: string, id: number, config: any, keys: Array<{ __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null }>, services: Array<{ __typename: 'Service', id: number, name: ServiceName, host: string | null, user: string | null, path: string | null } | null>, personalData: { __typename?: 'PersonalData', contactSchema: ContactSchema } } };

export type AddOrgMutationVariables = Exact<{
  org: OrgInput;
}>;


export type AddOrgMutation = { __typename?: 'RootMutationType', addOrg: { __typename: 'PrivateOrg', name: string, title: string, id: number, config: any, keys: Array<{ __typename: 'Key', id: number, name: string, public: string, active: boolean, expired: boolean, expiredAt: any | null }>, services: Array<{ __typename: 'Service', id: number, name: ServiceName, host: string | null, user: string | null, path: string | null } | null>, personalData: { __typename?: 'PersonalData', contactSchema: ContactSchema } } | { __typename?: 'PublicOrg' } };

export type JoinOrgMutationVariables = Exact<{
  orgName: Scalars['String'];
}>;


export type JoinOrgMutation = { __typename?: 'RootMutationType', joinOrg: { __typename?: 'JoinOrgResult', status: Status } };

export type UpdateProcessingMutationVariables = Exact<{
  orgName: Scalars['String'];
  emailBackend: ServiceName;
  emailFrom: Scalars['String'];
}>;


export type UpdateProcessingMutation = { __typename?: 'RootMutationType', updateOrgProcessing: { __typename?: 'PrivateOrg', name: string, processing: { __typename?: 'Processing', emailBackend: ServiceName | null, emailFrom: string | null } } };

export type InviteOrgUserMutationVariables = Exact<{
  orgName: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
}>;


export type InviteOrgUserMutation = { __typename?: 'RootMutationType', inviteOrgUser: { __typename?: 'Confirm', code: string } };

export type CampaignPartnershipsFragment = { __typename: 'PrivateCampaign', partnerships: Array<{ __typename?: 'Partnership', org: { __typename: 'PrivateOrg', config: any, id: number, name: string, title: string } | { __typename: 'PublicOrg', config: any, name: string, title: string }, actionPages: Array<{ __typename: 'PrivateActionPage', extraSupporters: number, delivery: boolean, location: string | null, status: ActionPageStatus | null, id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> }>, launchRequests: Array<{ __typename?: 'Confirm', code: string, email: string | null, message: string | null, objectId: number | null, creator: { __typename?: 'User', email: string, jobTitle: string | null } | null }>, launchRequesters: Array<{ __typename?: 'User', email: string, jobTitle: string | null }> }> | null };

export type LaunchActionPageMutationVariables = Exact<{
  name: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}>;


export type LaunchActionPageMutation = { __typename?: 'RootMutationType', launchActionPage: { __typename?: 'LaunchActionPageResult', status: Status } };

export type AcceptLaunchRequestMutationVariables = Exact<{
  org: Scalars['String'];
  confirm: ConfirmInput;
}>;


export type AcceptLaunchRequestMutation = { __typename?: 'RootMutationType', acceptOrgConfirm: { __typename?: 'ConfirmResult', status: Status, actionPage: { __typename: 'PrivateActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | { __typename: 'PublicActionPage', id: number, name: string, locale: string, config: any, live: boolean, journey: Array<string> } | null } };

export type RejectLaunchRequestMutationVariables = Exact<{
  org: Scalars['String'];
  confirm: ConfirmInput;
}>;


export type RejectLaunchRequestMutation = { __typename?: 'RootMutationType', rejectOrgConfirm: { __typename?: 'ConfirmResult', status: Status } };

export type UserInfoFragment = { __typename: 'User', id: number, email: string, roles: Array<{ __typename?: 'UserRole', role: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } }>, apiToken: { __typename?: 'ApiToken', expiresAt: any } | null };

export type CurrentUserOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserOrgsQuery = { __typename?: 'RootQueryType', currentUser: { __typename: 'User', id: number, email: string, roles: Array<{ __typename?: 'UserRole', role: string, org: { __typename: 'PrivateOrg', id: number, name: string, title: string, config: any } | { __typename: 'PublicOrg', name: string, title: string, config: any } }>, apiToken: { __typename?: 'ApiToken', expiresAt: any } | null } };

export type AcceptInviteMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'RootMutationType', acceptUserConfirm: { __typename?: 'ConfirmResult', status: Status, org: { __typename: 'PrivateOrg', name: string, title: string } | { __typename: 'PublicOrg', name: string, title: string } | null } };

export type ResetApiTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetApiTokenMutation = { __typename?: 'RootMutationType', resetApiToken: string };

export const ActionPageIdsFragmentDoc = `
    fragment actionPageIds on ActionPage {
  id
  name
  locale
}
    `;
export const ActionPageFieldsFragmentDoc = `
    fragment actionPageFields on ActionPage {
  __typename
  id
  name
  locale
  config
  live
  journey
}
    `;
export const OrgIdsFragmentDoc = `
    fragment orgIds on Org {
  __typename
  name
  title
  config
  ... on PrivateOrg {
    __typename
    id
  }
}
    `;
export const CampaignIdsFragmentDoc = `
    fragment campaignIds on Campaign {
  __typename
  id
  externalId
  name
  title
}
    `;
export const ActionPageCompleteFragmentDoc = `
    fragment ActionPageComplete on ActionPage {
  ...actionPageFields
  org {
    ...orgIds
  }
  campaign {
    ...campaignIds
  }
}
    ${ActionPageFieldsFragmentDoc}
${OrgIdsFragmentDoc}
${CampaignIdsFragmentDoc}`;
export const ActionPagePrivateFieldsFragmentDoc = `
    fragment actionPagePrivateFields on PrivateActionPage {
  __typename
  extraSupporters
  delivery
  location
  status
}
    `;
export const OrgActionPageFragmentDoc = `
    fragment orgActionPage on ActionPage {
  ...actionPageFields
  ... on PrivateActionPage {
    ...actionPagePrivateFields
  }
  campaign {
    ...campaignIds
    org {
      ...orgIds
    }
  }
}
    ${ActionPageFieldsFragmentDoc}
${ActionPagePrivateFieldsFragmentDoc}
${CampaignIdsFragmentDoc}
${OrgIdsFragmentDoc}`;
export const CampaignExportIdsFragmentDoc = `
    fragment campaignExportIds on Campaign {
  __typename
  name
  externalId
}
    `;
export const CampaignFieldsFragmentDoc = `
    fragment campaignFields on Campaign {
  __typename
  id
  externalId
  name
  title
  contactSchema
  config
}
    `;
export const CampaignCoalitionStatsFragmentDoc = `
    fragment campaignCoalitionStats on Campaign {
  __typename
  stats {
    supporterCount
    supporterCountByOrg {
      org {
        name
        title
      }
      count
    }
    actionCount {
      actionType
      count
    }
  }
}
    `;
export const CampaignPrivateFieldsFragmentDoc = `
    fragment campaignPrivateFields on PrivateCampaign {
  __typename
  forceDelivery
}
    `;
export const CampaignPartnershipsFragmentDoc = `
    fragment campaignPartnerships on PrivateCampaign {
  __typename
  partnerships {
    org {
      ...orgIds
      config
    }
    actionPages {
      ...actionPageFields
      ... on PrivateActionPage {
        ...actionPagePrivateFields
      }
    }
    launchRequests {
      code
      email
      message
      objectId
      creator {
        email
        jobTitle
      }
    }
    launchRequesters {
      email
      jobTitle
    }
  }
}
    ${OrgIdsFragmentDoc}
${ActionPageFieldsFragmentDoc}
${ActionPagePrivateFieldsFragmentDoc}`;
export const CampaignInfoFragmentDoc = `
    fragment campaignInfo on Campaign {
  __typename
  ...campaignFields
  ...campaignCoalitionStats
  ... on PrivateCampaign {
    ...campaignPrivateFields
    ...campaignPartnerships
  }
  org {
    ...orgIds
  }
}
    ${CampaignFieldsFragmentDoc}
${CampaignCoalitionStatsFragmentDoc}
${CampaignPrivateFieldsFragmentDoc}
${CampaignPartnershipsFragmentDoc}
${OrgIdsFragmentDoc}`;
export const PublicCampaignInfoFragmentDoc = `
    fragment publicCampaignInfo on Campaign {
  ...campaignFields
  org {
    ...orgIds
  }
}
    ${CampaignFieldsFragmentDoc}
${OrgIdsFragmentDoc}`;
export const ContactExportFragmentDoc = `
    fragment contactExport on Contact {
  contactRef
  payload
  nonce
  publicKey {
    id
    public
  }
  signKey {
    id
    public
  }
}
    `;
export const ActionExportFragmentDoc = `
    fragment actionExport on Action {
  actionId
  actionType
  createdAt
  contact {
    ...contactExport
  }
  customFields
  tracking {
    source
    medium
    campaign
    content
  }
  privacy {
    optIn
    givenAt
    emailStatus
    emailStatusChanged
    withConsent
  }
}
    ${ContactExportFragmentDoc}`;
export const OrgFieldsFragmentDoc = `
    fragment orgFields on Org {
  __typename
  name
  title
}
    `;
export const OrgPrivateFieldsFragmentDoc = `
    fragment orgPrivateFields on PrivateOrg {
  __typename
  id
  config
  personalData {
    contactSchema
  }
}
    `;
export const KeyFieldsFragmentDoc = `
    fragment keyFields on Key {
  __typename
  id
  name
  public
  active
  expired
  expiredAt
}
    `;
export const ServiceFieldsFragmentDoc = `
    fragment serviceFields on Service {
  __typename
  id
  name
  host
  user
  path
}
    `;
export const OrgInfoFragmentDoc = `
    fragment orgInfo on PrivateOrg {
  __typename
  ...orgFields
  ...orgPrivateFields
  keys(select: {active: true}) {
    ...keyFields
  }
  services {
    ...serviceFields
  }
}
    ${OrgFieldsFragmentDoc}
${OrgPrivateFieldsFragmentDoc}
${KeyFieldsFragmentDoc}
${ServiceFieldsFragmentDoc}`;
export const UserInfoFragmentDoc = `
    fragment userInfo on User {
  __typename
  id
  email
  roles {
    role
    org {
      ...orgIds
    }
  }
  apiToken {
    expiresAt
  }
}
    ${OrgIdsFragmentDoc}`;
export const ActionPagesDocument = `
    query ActionPages($org: String!) {
  org(name: $org) {
    actionPages {
      ...orgActionPage
    }
  }
}
    ${OrgActionPageFragmentDoc}`;
export const useActionPagesQuery = <
      TData = ActionPagesQuery,
      TError = CombinedError
    >(
      variables: ActionPagesQueryVariables,
      options?: UseQueryOptions<ActionPagesQuery, TError, TData>
    ) =>
    useQuery<ActionPagesQuery, TError, TData>(
      ['ActionPages', variables],
      useUrqlFetcher<ActionPagesQuery, ActionPagesQueryVariables>(ActionPagesDocument).bind(null, variables),
      options
    );
useActionPagesQuery.document = ActionPagesDocument;


useActionPagesQuery.getKey = (variables: ActionPagesQueryVariables) => ['ActionPages', variables];
;

export const ActionPageDocument = `
    query ActionPage($id: Int!) {
  actionPage(id: $id) {
    ...ActionPageComplete
  }
}
    ${ActionPageCompleteFragmentDoc}`;
export const useActionPageQuery = <
      TData = ActionPageQuery,
      TError = CombinedError
    >(
      variables: ActionPageQueryVariables,
      options?: UseQueryOptions<ActionPageQuery, TError, TData>
    ) =>
    useQuery<ActionPageQuery, TError, TData>(
      ['ActionPage', variables],
      useUrqlFetcher<ActionPageQuery, ActionPageQueryVariables>(ActionPageDocument).bind(null, variables),
      options
    );
useActionPageQuery.document = ActionPageDocument;


useActionPageQuery.getKey = (variables: ActionPageQueryVariables) => ['ActionPage', variables];
;

export const GetActionPageByNameDocument = `
    query GetActionPageByName($name: String!) {
  actionPage(name: $name) {
    ...actionPageFields
    ...actionPagePrivateFields
  }
}
    ${ActionPageFieldsFragmentDoc}
${ActionPagePrivateFieldsFragmentDoc}`;
export const useGetActionPageByNameQuery = <
      TData = GetActionPageByNameQuery,
      TError = CombinedError
    >(
      variables: GetActionPageByNameQueryVariables,
      options?: UseQueryOptions<GetActionPageByNameQuery, TError, TData>
    ) =>
    useQuery<GetActionPageByNameQuery, TError, TData>(
      ['GetActionPageByName', variables],
      useUrqlFetcher<GetActionPageByNameQuery, GetActionPageByNameQueryVariables>(GetActionPageByNameDocument).bind(null, variables),
      options
    );
useGetActionPageByNameQuery.document = GetActionPageByNameDocument;


useGetActionPageByNameQuery.getKey = (variables: GetActionPageByNameQueryVariables) => ['GetActionPageByName', variables];
;

export const GetOrgActionPageDocument = `
    query GetOrgActionPage($orgName: String!, $name: String!) {
  org(name: $orgName) {
    actionPage(name: $name) {
      ...orgActionPage
    }
  }
}
    ${OrgActionPageFragmentDoc}`;
export const useGetOrgActionPageQuery = <
      TData = GetOrgActionPageQuery,
      TError = CombinedError
    >(
      variables: GetOrgActionPageQueryVariables,
      options?: UseQueryOptions<GetOrgActionPageQuery, TError, TData>
    ) =>
    useQuery<GetOrgActionPageQuery, TError, TData>(
      ['GetOrgActionPage', variables],
      useUrqlFetcher<GetOrgActionPageQuery, GetOrgActionPageQueryVariables>(GetOrgActionPageDocument).bind(null, variables),
      options
    );
useGetOrgActionPageQuery.document = GetOrgActionPageDocument;


useGetOrgActionPageQuery.getKey = (variables: GetOrgActionPageQueryVariables) => ['GetOrgActionPage', variables];
;

export const UpdateActionPageDocument = `
    mutation UpdateActionPage($id: Int!, $actionPage: ActionPageInput!) {
  updateActionPage(id: $id, input: $actionPage) {
    ...orgActionPage
  }
}
    ${OrgActionPageFragmentDoc}`;
export const useUpdateActionPageMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateActionPageMutation, TError, UpdateActionPageMutationVariables, TContext>) =>
    useMutation<UpdateActionPageMutation, TError, UpdateActionPageMutationVariables, TContext>(
      ['UpdateActionPage'],
      useUrqlFetcher<UpdateActionPageMutation, UpdateActionPageMutationVariables>(UpdateActionPageDocument),
      options
    );
export const AddActionPageDocument = `
    mutation AddActionPage($orgName: String!, $campaignName: String!, $name: String!, $locale: String!, $config: Json) {
  addActionPage(
    orgName: $orgName
    campaignName: $campaignName
    input: {name: $name, locale: $locale, config: $config}
  ) {
    ...orgActionPage
  }
}
    ${OrgActionPageFragmentDoc}`;
export const useAddActionPageMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AddActionPageMutation, TError, AddActionPageMutationVariables, TContext>) =>
    useMutation<AddActionPageMutation, TError, AddActionPageMutationVariables, TContext>(
      ['AddActionPage'],
      useUrqlFetcher<AddActionPageMutation, AddActionPageMutationVariables>(AddActionPageDocument),
      options
    );
export const GetCampaignDocument = `
    query GetCampaign($org: String!, $id: Int!) {
  org(name: $org) {
    campaign(id: $id) {
      ...campaignInfo
    }
    actionPages(select: {campaignId: $id}) {
      ...actionPageFields
      ... on PrivateActionPage {
        ...actionPagePrivateFields
      }
    }
  }
}
    ${CampaignInfoFragmentDoc}
${ActionPageFieldsFragmentDoc}
${ActionPagePrivateFieldsFragmentDoc}`;
export const useGetCampaignQuery = <
      TData = GetCampaignQuery,
      TError = CombinedError
    >(
      variables: GetCampaignQueryVariables,
      options?: UseQueryOptions<GetCampaignQuery, TError, TData>
    ) =>
    useQuery<GetCampaignQuery, TError, TData>(
      ['GetCampaign', variables],
      useUrqlFetcher<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument).bind(null, variables),
      options
    );
useGetCampaignQuery.document = GetCampaignDocument;


useGetCampaignQuery.getKey = (variables: GetCampaignQueryVariables) => ['GetCampaign', variables];
;

export const GetCampaignConfigDocument = `
    query GetCampaignConfig($id: Int, $name: String) {
  campaign(id: $id, name: $name) {
    config
  }
}
    `;
export const useGetCampaignConfigQuery = <
      TData = GetCampaignConfigQuery,
      TError = CombinedError
    >(
      variables?: GetCampaignConfigQueryVariables,
      options?: UseQueryOptions<GetCampaignConfigQuery, TError, TData>
    ) =>
    useQuery<GetCampaignConfigQuery, TError, TData>(
      variables === undefined ? ['GetCampaignConfig'] : ['GetCampaignConfig', variables],
      useUrqlFetcher<GetCampaignConfigQuery, GetCampaignConfigQueryVariables>(GetCampaignConfigDocument).bind(null, variables),
      options
    );
useGetCampaignConfigQuery.document = GetCampaignConfigDocument;


useGetCampaignConfigQuery.getKey = (variables?: GetCampaignConfigQueryVariables) => variables === undefined ? ['GetCampaignConfig'] : ['GetCampaignConfig', variables];
;

export const UpsertCampaignDocument = `
    mutation UpsertCampaign($org: String!, $campaign: CampaignInput!) {
  upsertCampaign(orgName: $org, input: $campaign) {
    ...campaignInfo
  }
}
    ${CampaignInfoFragmentDoc}`;
export const useUpsertCampaignMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCampaignMutation, TError, UpsertCampaignMutationVariables, TContext>) =>
    useMutation<UpsertCampaignMutation, TError, UpsertCampaignMutationVariables, TContext>(
      ['UpsertCampaign'],
      useUrqlFetcher<UpsertCampaignMutation, UpsertCampaignMutationVariables>(UpsertCampaignDocument),
      options
    );
export const AddCampaignDocument = `
    mutation AddCampaign($org: String!, $campaign: CampaignInput!) {
  addCampaign(orgName: $org, input: $campaign) {
    ...campaignInfo
  }
}
    ${CampaignInfoFragmentDoc}`;
export const useAddCampaignMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AddCampaignMutation, TError, AddCampaignMutationVariables, TContext>) =>
    useMutation<AddCampaignMutation, TError, AddCampaignMutationVariables, TContext>(
      ['AddCampaign'],
      useUrqlFetcher<AddCampaignMutation, AddCampaignMutationVariables>(AddCampaignDocument),
      options
    );
export const UpdateCampaignByIdDocument = `
    mutation UpdateCampaignById($id: Int!, $campaign: CampaignInput!) {
  updateCampaign(id: $id, input: $campaign) {
    ...campaignInfo
  }
}
    ${CampaignInfoFragmentDoc}`;
export const useUpdateCampaignByIdMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCampaignByIdMutation, TError, UpdateCampaignByIdMutationVariables, TContext>) =>
    useMutation<UpdateCampaignByIdMutation, TError, UpdateCampaignByIdMutationVariables, TContext>(
      ['UpdateCampaignById'],
      useUrqlFetcher<UpdateCampaignByIdMutation, UpdateCampaignByIdMutationVariables>(UpdateCampaignByIdDocument),
      options
    );
export const FindPublicCampaignDocument = `
    query FindPublicCampaign($name: String, $title: String) {
  campaigns(title: $title, name: $name) {
    ...publicCampaignInfo
  }
}
    ${PublicCampaignInfoFragmentDoc}`;
export const useFindPublicCampaignQuery = <
      TData = FindPublicCampaignQuery,
      TError = CombinedError
    >(
      variables?: FindPublicCampaignQueryVariables,
      options?: UseQueryOptions<FindPublicCampaignQuery, TError, TData>
    ) =>
    useQuery<FindPublicCampaignQuery, TError, TData>(
      variables === undefined ? ['FindPublicCampaign'] : ['FindPublicCampaign', variables],
      useUrqlFetcher<FindPublicCampaignQuery, FindPublicCampaignQueryVariables>(FindPublicCampaignDocument).bind(null, variables),
      options
    );
useFindPublicCampaignQuery.document = FindPublicCampaignDocument;


useFindPublicCampaignQuery.getKey = (variables?: FindPublicCampaignQueryVariables) => variables === undefined ? ['FindPublicCampaign'] : ['FindPublicCampaign', variables];
;

export const CampaignDocument = `
    query Campaign($id: Int!) {
  campaign(id: $id) {
    ...campaignInfo
    org {
      ...orgIds
    }
  }
}
    ${CampaignInfoFragmentDoc}
${OrgIdsFragmentDoc}`;
export const useCampaignQuery = <
      TData = CampaignQuery,
      TError = CombinedError
    >(
      variables: CampaignQueryVariables,
      options?: UseQueryOptions<CampaignQuery, TError, TData>
    ) =>
    useQuery<CampaignQuery, TError, TData>(
      ['Campaign', variables],
      useUrqlFetcher<CampaignQuery, CampaignQueryVariables>(CampaignDocument).bind(null, variables),
      options
    );
useCampaignQuery.document = CampaignDocument;


useCampaignQuery.getKey = (variables: CampaignQueryVariables) => ['Campaign', variables];
;

export const CampaignsDocument = `
    query Campaigns($org: String!) {
  org(name: $org) {
    campaigns {
      ...campaignInfo
    }
  }
}
    ${CampaignInfoFragmentDoc}`;
export const useCampaignsQuery = <
      TData = CampaignsQuery,
      TError = CombinedError
    >(
      variables: CampaignsQueryVariables,
      options?: UseQueryOptions<CampaignsQuery, TError, TData>
    ) =>
    useQuery<CampaignsQuery, TError, TData>(
      ['Campaigns', variables],
      useUrqlFetcher<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument).bind(null, variables),
      options
    );
useCampaignsQuery.document = CampaignsDocument;


useCampaignsQuery.getKey = (variables: CampaignsQueryVariables) => ['Campaigns', variables];
;

export const AddCampaignPageDocument = `
    mutation AddCampaignPage($org: String!, $campaignName: String!, $campaign: CampaignInput!, $page: ActionPageInput!) {
  addCampaign(orgName: $org, input: $campaign) {
    ...campaignInfo
  }
  addActionPage(orgName: $org, campaignName: $campaignName, input: $page) {
    ...orgActionPage
  }
}
    ${CampaignInfoFragmentDoc}
${OrgActionPageFragmentDoc}`;
export const useAddCampaignPageMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AddCampaignPageMutation, TError, AddCampaignPageMutationVariables, TContext>) =>
    useMutation<AddCampaignPageMutation, TError, AddCampaignPageMutationVariables, TContext>(
      ['AddCampaignPage'],
      useUrqlFetcher<AddCampaignPageMutation, AddCampaignPageMutationVariables>(AddCampaignPageDocument),
      options
    );
export const ExportCampaignActionsDocument = `
    query ExportCampaignActions($org: String!, $campaignId: Int, $campaignName: String, $start: Int, $after: DateTime, $limit: Int, $onlyOptIn: Boolean, $onlyDoubleOptIn: Boolean) {
  exportActions(
    orgName: $org
    campaignId: $campaignId
    campaignName: $campaignName
    start: $start
    after: $after
    limit: $limit
    onlyOptIn: $onlyOptIn
    onlyDoubleOptIn: $onlyDoubleOptIn
  ) {
    ...actionExport
    actionPage {
      ...actionPageIds
    }
  }
}
    ${ActionExportFragmentDoc}
${ActionPageIdsFragmentDoc}`;
export const useExportCampaignActionsQuery = <
      TData = ExportCampaignActionsQuery,
      TError = CombinedError
    >(
      variables: ExportCampaignActionsQueryVariables,
      options?: UseQueryOptions<ExportCampaignActionsQuery, TError, TData>
    ) =>
    useQuery<ExportCampaignActionsQuery, TError, TData>(
      ['ExportCampaignActions', variables],
      useUrqlFetcher<ExportCampaignActionsQuery, ExportCampaignActionsQueryVariables>(ExportCampaignActionsDocument).bind(null, variables),
      options
    );
useExportCampaignActionsQuery.document = ExportCampaignActionsDocument;


useExportCampaignActionsQuery.getKey = (variables: ExportCampaignActionsQueryVariables) => ['ExportCampaignActions', variables];
;

export const ExportOrgActionsDocument = `
    query ExportOrgActions($org: String!, $start: Int, $after: DateTime, $limit: Int, $onlyOptIn: Boolean, $onlyDoubleOptIn: Boolean) {
  exportActions(
    orgName: $org
    start: $start
    after: $after
    limit: $limit
    onlyOptIn: $onlyOptIn
    onlyDoubleOptIn: $onlyDoubleOptIn
  ) {
    ...actionExport
    actionPage {
      ...actionPageIds
    }
    campaign {
      ...campaignExportIds
    }
  }
}
    ${ActionExportFragmentDoc}
${ActionPageIdsFragmentDoc}
${CampaignExportIdsFragmentDoc}`;
export const useExportOrgActionsQuery = <
      TData = ExportOrgActionsQuery,
      TError = CombinedError
    >(
      variables: ExportOrgActionsQueryVariables,
      options?: UseQueryOptions<ExportOrgActionsQuery, TError, TData>
    ) =>
    useQuery<ExportOrgActionsQuery, TError, TData>(
      ['ExportOrgActions', variables],
      useUrqlFetcher<ExportOrgActionsQuery, ExportOrgActionsQueryVariables>(ExportOrgActionsDocument).bind(null, variables),
      options
    );
useExportOrgActionsQuery.document = ExportOrgActionsDocument;


useExportOrgActionsQuery.getKey = (variables: ExportOrgActionsQueryVariables) => ['ExportOrgActions', variables];
;

export const ListKeysDocument = `
    query ListKeys($org: String!) {
  org(name: $org) {
    keys {
      ...keyFields
    }
  }
}
    ${KeyFieldsFragmentDoc}`;
export const useListKeysQuery = <
      TData = ListKeysQuery,
      TError = CombinedError
    >(
      variables: ListKeysQueryVariables,
      options?: UseQueryOptions<ListKeysQuery, TError, TData>
    ) =>
    useQuery<ListKeysQuery, TError, TData>(
      ['ListKeys', variables],
      useUrqlFetcher<ListKeysQuery, ListKeysQueryVariables>(ListKeysDocument).bind(null, variables),
      options
    );
useListKeysQuery.document = ListKeysDocument;


useListKeysQuery.getKey = (variables: ListKeysQueryVariables) => ['ListKeys', variables];
;

export const GenerateKeyDocument = `
    mutation GenerateKey($org: String!, $input: GenKeyInput!) {
  generateKey(orgName: $org, input: $input) {
    id
    name
    public
    private
    active
    expired
    expiredAt
  }
}
    `;
export const useGenerateKeyMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateKeyMutation, TError, GenerateKeyMutationVariables, TContext>) =>
    useMutation<GenerateKeyMutation, TError, GenerateKeyMutationVariables, TContext>(
      ['GenerateKey'],
      useUrqlFetcher<GenerateKeyMutation, GenerateKeyMutationVariables>(GenerateKeyDocument),
      options
    );
export const AddKeyDocument = `
    mutation AddKey($org: String!, $input: AddKeyInput!) {
  addKey(orgName: $org, input: $input) {
    id
    name
    public
    active
    expired
    expiredAt
  }
}
    `;
export const useAddKeyMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AddKeyMutation, TError, AddKeyMutationVariables, TContext>) =>
    useMutation<AddKeyMutation, TError, AddKeyMutationVariables, TContext>(
      ['AddKey'],
      useUrqlFetcher<AddKeyMutation, AddKeyMutationVariables>(AddKeyDocument),
      options
    );
export const ActivateKeyDocument = `
    mutation ActivateKey($org: String!, $id: Int!) {
  activateKey(orgName: $org, id: $id) {
    status
  }
}
    `;
export const useActivateKeyMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<ActivateKeyMutation, TError, ActivateKeyMutationVariables, TContext>) =>
    useMutation<ActivateKeyMutation, TError, ActivateKeyMutationVariables, TContext>(
      ['ActivateKey'],
      useUrqlFetcher<ActivateKeyMutation, ActivateKeyMutationVariables>(ActivateKeyDocument),
      options
    );
export const GetOrgDocument = `
    query GetOrg($org: String!) {
  org(name: $org) {
    ... on PrivateOrg {
      ...orgInfo
    }
  }
}
    ${OrgInfoFragmentDoc}`;
export const useGetOrgQuery = <
      TData = GetOrgQuery,
      TError = CombinedError
    >(
      variables: GetOrgQueryVariables,
      options?: UseQueryOptions<GetOrgQuery, TError, TData>
    ) =>
    useQuery<GetOrgQuery, TError, TData>(
      ['GetOrg', variables],
      useUrqlFetcher<GetOrgQuery, GetOrgQueryVariables>(GetOrgDocument).bind(null, variables),
      options
    );
useGetOrgQuery.document = GetOrgDocument;


useGetOrgQuery.getKey = (variables: GetOrgQueryVariables) => ['GetOrg', variables];
;

export const UpdateOrgDocument = `
    mutation UpdateOrg($orgName: String!, $org: OrgInput!) {
  updateOrg(name: $orgName, input: $org) {
    ... on PrivateOrg {
      ...orgInfo
    }
  }
}
    ${OrgInfoFragmentDoc}`;
export const useUpdateOrgMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrgMutation, TError, UpdateOrgMutationVariables, TContext>) =>
    useMutation<UpdateOrgMutation, TError, UpdateOrgMutationVariables, TContext>(
      ['UpdateOrg'],
      useUrqlFetcher<UpdateOrgMutation, UpdateOrgMutationVariables>(UpdateOrgDocument),
      options
    );
export const AddOrgDocument = `
    mutation AddOrg($org: OrgInput!) {
  addOrg(input: $org) {
    ... on PrivateOrg {
      ...orgInfo
    }
  }
}
    ${OrgInfoFragmentDoc}`;
export const useAddOrgMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrgMutation, TError, AddOrgMutationVariables, TContext>) =>
    useMutation<AddOrgMutation, TError, AddOrgMutationVariables, TContext>(
      ['AddOrg'],
      useUrqlFetcher<AddOrgMutation, AddOrgMutationVariables>(AddOrgDocument),
      options
    );
export const JoinOrgDocument = `
    mutation JoinOrg($orgName: String!) {
  joinOrg(name: $orgName) {
    status
  }
}
    `;
export const useJoinOrgMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<JoinOrgMutation, TError, JoinOrgMutationVariables, TContext>) =>
    useMutation<JoinOrgMutation, TError, JoinOrgMutationVariables, TContext>(
      ['JoinOrg'],
      useUrqlFetcher<JoinOrgMutation, JoinOrgMutationVariables>(JoinOrgDocument),
      options
    );
export const UpdateProcessingDocument = `
    mutation updateProcessing($orgName: String!, $emailBackend: ServiceName!, $emailFrom: String!) {
  updateOrgProcessing(
    name: $orgName
    emailBackend: $emailBackend
    emailFrom: $emailFrom
  ) {
    name
    processing {
      emailBackend
      emailFrom
    }
  }
}
    `;
export const useUpdateProcessingMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProcessingMutation, TError, UpdateProcessingMutationVariables, TContext>) =>
    useMutation<UpdateProcessingMutation, TError, UpdateProcessingMutationVariables, TContext>(
      ['updateProcessing'],
      useUrqlFetcher<UpdateProcessingMutation, UpdateProcessingMutationVariables>(UpdateProcessingDocument),
      options
    );
export const InviteOrgUserDocument = `
    mutation InviteOrgUser($orgName: String!, $email: String!, $message: String!) {
  inviteOrgUser(
    orgName: $orgName
    message: $message
    input: {email: $email, role: "owner"}
  ) {
    code
  }
}
    `;
export const useInviteOrgUserMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<InviteOrgUserMutation, TError, InviteOrgUserMutationVariables, TContext>) =>
    useMutation<InviteOrgUserMutation, TError, InviteOrgUserMutationVariables, TContext>(
      ['InviteOrgUser'],
      useUrqlFetcher<InviteOrgUserMutation, InviteOrgUserMutationVariables>(InviteOrgUserDocument),
      options
    );
export const LaunchActionPageDocument = `
    mutation LaunchActionPage($name: String!, $message: String) {
  launchActionPage(name: $name, message: $message) {
    status
  }
}
    `;
export const useLaunchActionPageMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<LaunchActionPageMutation, TError, LaunchActionPageMutationVariables, TContext>) =>
    useMutation<LaunchActionPageMutation, TError, LaunchActionPageMutationVariables, TContext>(
      ['LaunchActionPage'],
      useUrqlFetcher<LaunchActionPageMutation, LaunchActionPageMutationVariables>(LaunchActionPageDocument),
      options
    );
export const AcceptLaunchRequestDocument = `
    mutation AcceptLaunchRequest($org: String!, $confirm: ConfirmInput!) {
  acceptOrgConfirm(name: $org, confirm: $confirm) {
    status
    actionPage {
      ...actionPageFields
    }
  }
}
    ${ActionPageFieldsFragmentDoc}`;
export const useAcceptLaunchRequestMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptLaunchRequestMutation, TError, AcceptLaunchRequestMutationVariables, TContext>) =>
    useMutation<AcceptLaunchRequestMutation, TError, AcceptLaunchRequestMutationVariables, TContext>(
      ['AcceptLaunchRequest'],
      useUrqlFetcher<AcceptLaunchRequestMutation, AcceptLaunchRequestMutationVariables>(AcceptLaunchRequestDocument),
      options
    );
export const RejectLaunchRequestDocument = `
    mutation RejectLaunchRequest($org: String!, $confirm: ConfirmInput!) {
  rejectOrgConfirm(name: $org, confirm: $confirm) {
    status
  }
}
    `;
export const useRejectLaunchRequestMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<RejectLaunchRequestMutation, TError, RejectLaunchRequestMutationVariables, TContext>) =>
    useMutation<RejectLaunchRequestMutation, TError, RejectLaunchRequestMutationVariables, TContext>(
      ['RejectLaunchRequest'],
      useUrqlFetcher<RejectLaunchRequestMutation, RejectLaunchRequestMutationVariables>(RejectLaunchRequestDocument),
      options
    );
export const CurrentUserOrgsDocument = `
    query CurrentUserOrgs {
  currentUser {
    ...userInfo
  }
}
    ${UserInfoFragmentDoc}`;
export const useCurrentUserOrgsQuery = <
      TData = CurrentUserOrgsQuery,
      TError = CombinedError
    >(
      variables?: CurrentUserOrgsQueryVariables,
      options?: UseQueryOptions<CurrentUserOrgsQuery, TError, TData>
    ) =>
    useQuery<CurrentUserOrgsQuery, TError, TData>(
      variables === undefined ? ['CurrentUserOrgs'] : ['CurrentUserOrgs', variables],
      useUrqlFetcher<CurrentUserOrgsQuery, CurrentUserOrgsQueryVariables>(CurrentUserOrgsDocument).bind(null, variables),
      options
    );
useCurrentUserOrgsQuery.document = CurrentUserOrgsDocument;


useCurrentUserOrgsQuery.getKey = (variables?: CurrentUserOrgsQueryVariables) => variables === undefined ? ['CurrentUserOrgs'] : ['CurrentUserOrgs', variables];
;

export const AcceptInviteDocument = `
    mutation AcceptInvite($email: String!, $code: String!) {
  acceptUserConfirm(confirm: {email: $email, code: $code}) {
    status
    org {
      ...orgFields
    }
  }
}
    ${OrgFieldsFragmentDoc}`;
export const useAcceptInviteMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptInviteMutation, TError, AcceptInviteMutationVariables, TContext>) =>
    useMutation<AcceptInviteMutation, TError, AcceptInviteMutationVariables, TContext>(
      ['AcceptInvite'],
      useUrqlFetcher<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument),
      options
    );
export const ResetApiTokenDocument = `
    mutation ResetApiToken {
  resetApiToken
}
    `;
export const useResetApiTokenMutation = <
      TError = CombinedError,
      TContext = unknown
    >(options?: UseMutationOptions<ResetApiTokenMutation, TError, ResetApiTokenMutationVariables, TContext>) =>
    useMutation<ResetApiTokenMutation, TError, ResetApiTokenMutationVariables, TContext>(
      ['ResetApiToken'],
      useUrqlFetcher<ResetApiTokenMutation, ResetApiTokenMutationVariables>(ResetApiTokenDocument),
      options
    );

export type ObjectFieldTypes = {
    [key: string]: { [key: string]: string | string[] }
};

export type OpTypes = {
    [key: string]: string | string[]
};

export type ScalarLocations = {
 scalars: string[],
 inputObjectFieldTypes: ObjectFieldTypes;
 outputObjectFieldTypes: ObjectFieldTypes;
 operationMap: OpTypes;
};

export const scalarLocations : ScalarLocations = {
  "inputObjectFieldTypes": {
    "ActionInput": {
      "customFields": "Json",
      "donation": "DonationActionInput",
      "fields": "CustomFieldInput",
      "mtt": "MttActionInput"
    },
    "ActionPageInput": {
      "config": "Json"
    },
    "CampaignInput": {
      "actionPages": "ActionPageInput",
      "config": "Json",
      "mtt": "CampaignMttInput"
    },
    "ContactInput": {
      "address": "AddressInput",
      "nationality": "NationalityInput"
    },
    "DonationActionInput": {
      "payload": "Json"
    },
    "OrgInput": {
      "config": "Json"
    },
    "TargetInput": {
      "emails": "TargetEmailInput",
      "fields": "Json"
    }
  },
  "outputObjectFieldTypes": {
    "Action": {
      "actionPage": [
        "PrivateActionPage",
        "PublicActionPage"
      ],
      "campaign": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "contact": "Contact",
      "customFields": "Json",
      "donation": "Donation",
      "fields": "CustomField",
      "privacy": "Consent",
      "tracking": "Tracking"
    },
    "ActionCustomFields": {
      "customFields": "Json",
      "fields": "CustomField"
    },
    "CampaignStats": {
      "actionCount": "ActionTypeCount",
      "supporterCountByArea": "AreaCount",
      "supporterCountByOrg": "OrgCount"
    },
    "Confirm": {
      "creator": "User"
    },
    "ConfirmResult": {
      "actionPage": [
        "PrivateActionPage",
        "PublicActionPage"
      ],
      "campaign": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "Contact": {
      "publicKey": "KeyIds",
      "signKey": "KeyIds"
    },
    "Donation": {
      "payload": "Json"
    },
    "JoinOrgResult": {
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "OrgCount": {
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "Partnership": {
      "actionPages": [
        "PrivateActionPage",
        "PublicActionPage"
      ],
      "launchRequesters": "User",
      "launchRequests": "Confirm",
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "PrivateActionPage": {
      "campaign": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "config": "Json",
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "PrivateCampaign": {
      "actionPages": "PrivateActionPage",
      "actions": "PublicActionsResult",
      "config": "Json",
      "mtt": "CampaignMtt",
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ],
      "partnerships": "Partnership",
      "stats": "CampaignStats",
      "targets": [
        "PrivateTarget",
        "PublicTarget"
      ]
    },
    "PrivateOrg": {
      "actionPage": [
        "PrivateActionPage",
        "PublicActionPage"
      ],
      "actionPages": [
        "PrivateActionPage",
        "PublicActionPage"
      ],
      "campaign": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "campaigns": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "config": "Json",
      "key": "Key",
      "keys": "Key",
      "personalData": "PersonalData",
      "processing": "Processing",
      "services": "Service",
      "users": "OrgUser"
    },
    "PrivateTarget": {
      "emails": "TargetEmail",
      "fields": "Json"
    },
    "PublicActionPage": {
      "campaign": [
        "PrivateCampaign",
        "PublicCampaign"
      ],
      "config": "Json",
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    },
    "PublicActionsResult": {
      "list": "ActionCustomFields"
    },
    "PublicCampaign": {
      "actions": "PublicActionsResult",
      "config": "Json",
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ],
      "stats": "CampaignStats",
      "targets": [
        "PrivateTarget",
        "PublicTarget"
      ]
    },
    "PublicOrg": {
      "config": "Json"
    },
    "PublicTarget": {
      "fields": "Json"
    },
    "User": {
      "apiToken": "ApiToken",
      "roles": "UserRole"
    },
    "UserRole": {
      "org": [
        "PrivateOrg",
        "PublicOrg"
      ]
    }
  },
  "operationMap": {
    "acceptOrgConfirm": "ConfirmResult",
    "acceptUserConfirm": "ConfirmResult",
    "activateKey": "ActivateKeyResult",
    "addAction": "ContactReference",
    "addActionContact": "ContactReference",
    "addActionPage": [
      "PrivateActionPage",
      "PublicActionPage"
    ],
    "addCampaign": [
      "PrivateCampaign",
      "PublicCampaign"
    ],
    "addKey": "Key",
    "addOrg": [
      "PrivateOrg",
      "PublicOrg"
    ],
    "addOrgUser": "ChangeUserStatus",
    "addStripeObject": "Json",
    "addStripePaymentIntent": "Json",
    "addStripeSubscription": "Json",
    "copyActionPage": [
      "PrivateActionPage",
      "PublicActionPage"
    ],
    "copyCampaignActionPage": [
      "PrivateActionPage",
      "PublicActionPage"
    ],
    "deleteOrgUser": "DeleteUserResult",
    "generateKey": "KeyWithPrivate",
    "inviteOrgUser": "Confirm",
    "joinOrg": "JoinOrgResult",
    "launchActionPage": "LaunchActionPageResult",
    "linkActions": "ContactReference",
    "rejectOrgConfirm": "ConfirmResult",
    "rejectUserConfirm": "ConfirmResult",
    "requeueActions": "RequeueResult",
    "updateActionPage": [
      "PrivateActionPage",
      "PublicActionPage"
    ],
    "updateCampaign": [
      "PrivateCampaign",
      "PublicCampaign"
    ],
    "updateOrg": "PrivateOrg",
    "updateOrgProcessing": "PrivateOrg",
    "updateOrgUser": "ChangeUserStatus",
    "updateUser": "User",
    "upsertCampaign": [
      "PrivateCampaign",
      "PublicCampaign"
    ],
    "upsertService": "Service",
    "upsertTargets": "PrivateTarget",
    "actionPage": [
      "PrivateActionPage",
      "PublicActionPage"
    ],
    "campaign": [
      "PrivateCampaign",
      "PublicCampaign"
    ],
    "campaigns": [
      "PrivateCampaign",
      "PublicCampaign"
    ],
    "currentUser": "User",
    "exportActions": "Action",
    "org": "PrivateOrg",
    "users": "User",
    "actionPageUpserted": [
      "PrivateActionPage",
      "PublicActionPage"
    ]
  },
  "scalars": [
    "Json"
  ]
};
